
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("ilIeg", function(module, exports) {

var $d925B = parcelRequire("d925B");

function $951fbaee997f5802$var$createAIUnifiedCommonAttributes(interactionID, experienceName, isProactive, traceIds, invokedFrom, nudgeMetrics) {
    return {
        singleInstrumentationID: interactionID ?? '',
        aiInteractionID: interactionID ?? '',
        aiFeatureName: 'Editor AI',
        aiExperienceName: experienceName ?? 'unknown',
        isAIFeature: 1,
        proactiveAIGenerated: !!isProactive ? 1 : 0,
        userGeneratedAI: !isProactive ? 1 : 0,
        traceIds: traceIds,
        invokedFrom: invokedFrom,
        nudgeMetrics: nudgeMetrics
    };
}
function $951fbaee997f5802$export$b0cd7b0ace1e359d({ action: action, interactionID: interactionID, attributes: attributes, experienceName: experienceName, isProactive: isProactive, invokedFrom: invokedFrom, traceIds: traceIds, nudgeMetrics: nudgeMetrics }) {
    const unifiedAnalyticsAttributes = $951fbaee997f5802$var$createAIUnifiedCommonAttributes(interactionID, experienceName, isProactive, traceIds, invokedFrom, nudgeMetrics);
    switch(action){
        case (0, $d925B.ACTION).ACTIONED:
            return {
                action: action,
                actionSubject: (0, $d925B.ACTION_SUBJECT).AI_RESULT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    aiResultAction: 'unknown',
                    ...unifiedAnalyticsAttributes,
                    ...attributes
                }
            };
        case (0, $d925B.ACTION).VIEWED:
        case (0, $d925B.ACTION).ERROR:
            return {
                action: action,
                actionSubject: (0, $d925B.ACTION_SUBJECT).AI_RESULT,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    ...unifiedAnalyticsAttributes,
                    ...attributes
                }
            };
        case (0, $d925B.ACTION).INITIATED:
        case (0, $d925B.ACTION).DISMISSED:
            return {
                action: action,
                actionSubject: (0, $d925B.ACTION_SUBJECT).AI_INTERACTION,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    ...unifiedAnalyticsAttributes,
                    ...attributes
                }
            };
        case (0, $d925B.ACTION).SUBMITTED:
            return {
                action: action,
                actionSubject: (0, $d925B.ACTION_SUBJECT).AI_FEEDBACK,
                actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).EDITOR_PLUGIN_AI,
                eventType: (0, $d925B.EVENT_TYPE).TRACK,
                attributes: {
                    // If feedback result is not explicitly set then we should assume negative, since people are more likely to
                    // report negative experiences than they are positive ones.
                    aiFeedbackResult: 'down',
                    ...unifiedAnalyticsAttributes,
                    ...attributes
                }
            };
    }
}
module.exports["createUnifiedAnalyticsPayload"] = $951fbaee997f5802$export$b0cd7b0ace1e359d;

});

parcelRegister("2QlXt", function(module, exports) {
class $d18f4572a8af9b70$export$7edca8cfa9634e37 {
    static extractErrorMessage(error) {
        if (error instanceof Error) return $d18f4572a8af9b70$export$7edca8cfa9634e37.redactSensitiveInfo(error.message || 'unknown-error');
        else return $d18f4572a8af9b70$export$7edca8cfa9634e37.redactSensitiveInfo(String(error));
    }
}
$d18f4572a8af9b70$export$7edca8cfa9634e37.redactSensitiveInfo = (str)=>{
    const redacted = str// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/[^,\s]+\@[^,\s]+/g, '[REDACTED EMAIL]')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/[^,\s]+\.[^,\s]+/g, '[REDACTED URL]');
    return redacted;
};
module.exports["ErrorUtils"] = $d18f4572a8af9b70$export$7edca8cfa9634e37;

});

parcelRegister("SFzFl", function(module, exports) {
$parcel$export(module.exports, "default", () => $e475b7743411e2ea$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $e475b7743411e2ea$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    aiUniversalLongCallToAction: {
        id: "fabric.editor.ai.shared.aiUniversalLongCallToAction",
        defaultMessage: "Let Atlassian Intelligence assist your writing"
    },
    rovoUniversalLongCallToAction: {
        id: "fabric.editor.ai.shared.rovoUniversalLongCallToAction",
        defaultMessage: "Collaborate with AI"
    },
    aiUniversalShortCallToAction: {
        id: "fabric.editor.ai.shared.aiUniversalShortCallToAction",
        defaultMessage: "Write"
    },
    aiProactiveButtonLabel: {
        id: "fabric.editor.ai.shared.aiProactiveButtonLabel",
        defaultMessage: "Suggestions"
    },
    aiProactiveDescriptor: {
        id: "fabric.editor.ai.shared.aiProactiveDescriptor.non-final",
        defaultMessage: "{count, plural, =0 {Open suggested edits} =1 {New suggested edit} =2 {Two new suggested edits} =3 {Three new suggested edits} =4 {Four new suggested edits} other {More than four new suggested edits}}"
    },
    aiProactiveCloseDescriptor: {
        id: "fabric.editor.ai.shared.aiProactiveDescriptorClose.non-final",
        defaultMessage: "Close suggested edits"
    },
    aiUniversalDescriptor: {
        id: "fabric.editor.ai.shared.aiUniversalDescriptor",
        defaultMessage: "Writing assistant"
    },
    aiButtonTitle: {
        id: "fabric.editor.ai.shared.generateContent.aiButtonTitle",
        defaultMessage: "AI (Atlassian Intelligence)"
    },
    rovoButtonTitle: {
        id: "fabric.editor.ai.shared.generateContent.rovoButtonTitle",
        defaultMessage: "Ask Rovo"
    },
    betaLabel: {
        id: "fabric.editor.ai.shared.betaLabel",
        defaultMessage: "Beta"
    }
});

});

parcelRegister("80JwR", function(module, exports) {

var $1S4f7 = parcelRequire("1S4f7");


var $1oCLl = parcelRequire("1oCLl");


var $d925B = parcelRequire("d925B");


var $hWRJP = parcelRequire("hWRJP");


var $l998X = parcelRequire("l998X");

parcelRequire("42omo");





var $4HWgE = parcelRequire("4HWgE");





var $2Yaht = parcelRequire("2Yaht");






var $ks2lK = parcelRequire("ks2lK");


var $ae8edf494757bf0e$export$5f9dbfce88541fe5 = /*#__PURE__*/ function(LoomPluginAction) {
    LoomPluginAction[LoomPluginAction["ENABLE"] = 0] = "ENABLE";
    LoomPluginAction[LoomPluginAction["DISABLE"] = 1] = "DISABLE";
    LoomPluginAction[LoomPluginAction["RECORD_VIDEO"] = 2] = "RECORD_VIDEO";
    LoomPluginAction[LoomPluginAction["INSERT_VIDEO"] = 3] = "INSERT_VIDEO";
    return LoomPluginAction;
}({});
const $ae8edf494757bf0e$export$db6b5ebe5a8c279 = new (0, $ks2lK.PluginKey)('loom');
const $ae8edf494757bf0e$export$ae829ec7b2625219 = ({ config: config, api: api })=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $ae8edf494757bf0e$export$db6b5ebe5a8c279,
        state: {
            init: ()=>({
                    isEnabled: false,
                    loomButton: null,
                    isRecordingVideo: false,
                    error: undefined
                }),
            apply: (tr, pluginState)=>{
                const action = tr.getMeta($ae8edf494757bf0e$export$db6b5ebe5a8c279)?.type;
                switch(action){
                    case 0:
                        const { loomButton: loomButton } = tr.getMeta($ae8edf494757bf0e$export$db6b5ebe5a8c279);
                        return {
                            ...pluginState,
                            isEnabled: true,
                            loomButton: loomButton
                        };
                    case 1:
                        const { error: error } = tr.getMeta($ae8edf494757bf0e$export$db6b5ebe5a8c279);
                        return {
                            ...pluginState,
                            isEnabled: false,
                            loomButton: null,
                            error: error
                        };
                    case 2:
                        // Click the unmounted button in state that has the Loom SDK attached
                        pluginState?.loomButton?.click();
                        return {
                            ...pluginState,
                            isRecordingVideo: true
                        };
                    case 3:
                        return {
                            ...pluginState,
                            isRecordingVideo: false
                        };
                    default:
                        return pluginState;
                }
            }
        },
        view (editorView) {
            if (config.loomProvider) (0, $a212a932479b4271$export$a39487b0b81d2404)(config.loomProvider, api, editorView);
            return {};
        }
    });
};


const $ad333a3a37885863$export$3432d7b65cad662d = (editorAnalyticsAPI)=>({ formatMessage: formatMessage })=>[
            {
                id: 'loom',
                title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).recordVideo),
                description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).recordVideoDescription),
                keywords: [
                    'loom',
                    'record',
                    'video'
                ],
                priority: 800,
                isDisabledOffline: true,
                icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))), {
                        label: "",
                        color: "var(--ds-icon-subtle, #505258)",
                        spacing: "spacious"
                    }),
                action (insert, editorState) {
                    const tr = insert(undefined);
                    const loomState = (0, $ae8edf494757bf0e$export$db6b5ebe5a8c279).getState(editorState);
                    if (!loomState?.isEnabled) {
                        const errorMessage = loomState?.error;
                        (0, $hWRJP.logException)(new Error(errorMessage), {
                            location: 'editor-plugin-loom/quick-insert-record-video'
                        });
                        return (0, $a212a932479b4271$export$3b5a9e613ed2ae87)({
                            inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT,
                            error: errorMessage,
                            editorAnalyticsAPI: editorAnalyticsAPI
                        })({
                            tr: tr
                        }) ?? false;
                    }
                    return (0, $a212a932479b4271$export$2d56b03ca3f4ead9)({
                        inputMethod: (0, $d925B.INPUT_METHOD).QUICK_INSERT,
                        editorAnalyticsAPI: editorAnalyticsAPI
                    })({
                        tr: tr
                    }) ?? false;
                }
            }
        ];



const $a212a932479b4271$export$b5c7c74886310ae0 = ({ loomButton: loomButton })=>({ tr: tr })=>{
        tr.setMeta((0, $ae8edf494757bf0e$export$db6b5ebe5a8c279), {
            type: (0, $ae8edf494757bf0e$export$5f9dbfce88541fe5).ENABLE,
            loomButton: loomButton
        });
        return tr;
    };
const $a212a932479b4271$export$6f61f49dd8b64c45 = ({ error: error })=>({ tr: tr })=>{
        tr.setMeta((0, $ae8edf494757bf0e$export$db6b5ebe5a8c279), {
            type: (0, $ae8edf494757bf0e$export$5f9dbfce88541fe5).DISABLE,
            error: error
        });
        return tr;
    };
const $a212a932479b4271$export$2d56b03ca3f4ead9 = ({ inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI })=>({ tr: tr })=>{
        tr.setMeta((0, $ae8edf494757bf0e$export$db6b5ebe5a8c279), {
            type: (0, $ae8edf494757bf0e$export$5f9dbfce88541fe5).RECORD_VIDEO
        });
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).RECORD_VIDEO,
            actionSubject: (0, $d925B.ACTION_SUBJECT).LOOM,
            attributes: {
                inputMethod: inputMethod
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    };
const $a212a932479b4271$export$3b5a9e613ed2ae87 = ({ inputMethod: inputMethod, error: error, editorAnalyticsAPI: editorAnalyticsAPI })=>({ tr: tr })=>{
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).RECORD_VIDEO_FAILED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).LOOM,
            attributes: {
                inputMethod: inputMethod,
                error: error
            },
            eventType: (0, $d925B.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    };
const $a212a932479b4271$export$73a289ac38fc1ec = ({ editorAnalyticsAPI: editorAnalyticsAPI, video: video })=>({ tr: tr })=>{
        tr.setMeta((0, $ae8edf494757bf0e$export$db6b5ebe5a8c279), {
            type: (0, $ae8edf494757bf0e$export$5f9dbfce88541fe5).INSERT_VIDEO
        });
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $d925B.ACTION).INSERT_VIDEO,
            actionSubject: (0, $d925B.ACTION_SUBJECT).LOOM,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                duration: video.duration
            }
        })(tr);
        return tr;
    };
const $a212a932479b4271$var$getPositions = (tr, posType)=>{
    const selection = tr.selection;
    switch(posType){
        case 'current':
            return {
                from: selection.from,
                to: selection.from
            };
        case 'start':
            return {
                from: 0,
                to: 0
            };
        case 'end':
            return {
                from: tr.doc.content.size,
                to: tr.doc.content.size
            };
    }
};
const $a212a932479b4271$export$e61f2d2bdaa7ecf4 = (editorView, api, video, positionType)=>{
    if (!editorView) return false;
    const { state: state, dispatch: dispatch } = editorView;
    const { from: from, to: to } = $a212a932479b4271$var$getPositions(state.tr, positionType);
    return api?.hyperlink?.actions.insertLink((0, $d925B.INPUT_METHOD).TYPEAHEAD, from, to, video.sharedUrl, video.title, undefined, undefined, undefined, 'embed')(state, dispatch) ?? false;
};
const $a212a932479b4271$export$92a5ff9a4d5c2287 = (api)=>{
    api?.core?.actions.execute($a212a932479b4271$export$2d56b03ca3f4ead9({
        inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR,
        editorAnalyticsAPI: api?.analytics?.actions
    }));
};
const $a212a932479b4271$export$a39487b0b81d2404 = async (loomProvider, api, editorView, /**
	 * Whether loom initialisation is evoked via `initLoom` command.
	 */ initViaCommand)=>{
    const clientResult = await loomProvider.getClient();
    if (clientResult.status === 'error') {
        api?.core?.actions.execute($a212a932479b4271$export$6f61f49dd8b64c45({
            error: clientResult.message
        }));
        (0, $hWRJP.logException)(new Error(clientResult.message), {
            location: 'editor-plugin-loom/sdk-initialisation'
        });
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $d925B.ACTION).ERRORED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).LOOM,
            eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: clientResult.message
            }
        });
        return {
            error: clientResult.message
        };
    }
    const { attachToButton: attachToButton } = clientResult.client;
    // Hidden element to work around the SDK API
    const loomButton = document.createElement('button');
    attachToButton({
        button: loomButton,
        onInsert: (video)=>{
            if (!editorView) return;
            const { state: state, dispatch: dispatch } = editorView;
            const pos = state.selection.from;
            api?.hyperlink?.actions.insertLink((0, $d925B.INPUT_METHOD).TYPEAHEAD, pos, pos, video.sharedUrl, video.title, undefined, undefined, undefined, 'embed')(state, dispatch);
            api?.core?.actions.execute($a212a932479b4271$export$73a289ac38fc1ec({
                editorAnalyticsAPI: api?.analytics?.actions,
                video: video
            }));
        }
    });
    api?.core?.actions.execute(({ tr: tr })=>{
        $a212a932479b4271$export$b5c7c74886310ae0({
            loomButton: loomButton
        })({
            tr: tr
        });
        if (initViaCommand) api?.quickInsert?.commands.addQuickInsertItem((0, $ad333a3a37885863$export$3432d7b65cad662d)(api?.analytics?.actions))({
            tr: tr
        });
        return tr;
    });
    // We're not combining the analytics steps into the enable / disable commands because the collab-edit plugin
    // filters out any transactions with steps (even analytics) when it's initialising.
    // Even if `initViaCommand` is true, collab-edit might not be ready depending on when `initLoom` is called,
    // hence the analytics step is added separately in both cases
    api?.analytics?.actions.fireAnalyticsEvent({
        action: (0, $d925B.ACTION).INITIALISED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).LOOM,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL
    });
    return {};
};



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $eiA8Z = parcelRequire("eiA8Z");


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 






var $gmMgo = parcelRequire("gmMgo");








var $8TW6I = parcelRequire("8TW6I");

var $a4eZN = parcelRequire("a4eZN");




function $e0f54c4226daf504$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// This const is derived from the breakpoint where the toolbar hides its icons. It is used to hide the text in the AI button.
// Derived from values from platform/packages/editor/editor-core/src/ui/Appearance/FullPage/MainToolbar.tsx
const $e0f54c4226daf504$var$LOOM_BUTTON_WIDTH_BREAKPOINT = 1076;
const $e0f54c4226daf504$var$iconMinWidthStyle = {
    name: "9bmev",
    styles: "min-width:24px"
};
const $e0f54c4226daf504$var$selector = (states)=>{
    return {
        width: states.widthState?.width
    };
};
const $e0f54c4226daf504$var$LoomToolbarButtonInternal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ disabled: disabled, api: api, appearance: appearance, intl: { formatMessage: formatMessage }, selected: selected, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, 'data-ds--level': dataDsLevel, onClick: onClick, href: href, target: target, hideTooltip: hideTooltip, rel: rel }, ref)=>{
    const { width: width } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'width'
    ], $e0f54c4226daf504$var$selector);
    const label = formatMessage(appearance === 'comment' ? (0, $4HWgE.toolbarInsertBlockMessages).addLoomVideoComment : (0, $4HWgE.toolbarInsertBlockMessages).addLoomVideo);
    const shouldShowRecordText = (width || 0) > $e0f54c4226daf504$var$LOOM_BUTTON_WIDTH_BREAKPOINT;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
        hideTooltip: hideTooltip,
        ref: ref,
        href: href,
        buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).RECORD_VIDEO,
        disabled: disabled,
        title: label,
        iconBefore: /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
            css: $e0f54c4226daf504$var$iconMinWidthStyle
        }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))), {
            label: label,
            color: disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)",
            spacing: "spacious"
        })),
        selected: selected,
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        "data-ds--level": dataDsLevel,
        onClick: onClick,
        target: target,
        rel: rel
    }, shouldShowRecordText && formatMessage((0, $4HWgE.toolbarInsertBlockMessages).recordLoomShortTitle));
});
var $e0f54c4226daf504$export$2e2bcd8739ae039 = (0, $gmMgo.default)($e0f54c4226daf504$var$LoomToolbarButtonInternal, {
    forwardRef: true
});


const $e04bd784ac086222$var$selector = (states)=>{
    return {
        loomEnabled: states.loomState?.isEnabled,
        connectivityMode: states.connectivityState?.mode
    };
};
const $e04bd784ac086222$var$CustomisableLoomToolbarButton = (disabled, appearance, api)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
        const { onClickBeforeInit: onClickBeforeInit, isDisabled: isDisabled = false, href: href, ...restProps } = props;
        const { loomEnabled: loomEnabled, connectivityMode: connectivityMode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
            'loom',
            'connectivity'
        ], $e04bd784ac086222$var$selector);
        const isLoomEnabled = !!loomEnabled;
        const handleOnClick = (0, $42omo.useCallback)((e)=>{
            if (isLoomEnabled) (0, $a212a932479b4271$export$92a5ff9a4d5c2287)(api);
            else onClickBeforeInit && onClickBeforeInit(e);
        }, [
            isLoomEnabled,
            onClickBeforeInit
        ]);
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $e0f54c4226daf504$export$2e2bcd8739ae039), {
            ref: ref,
            hideTooltip: !!(restProps.onMouseEnter || restProps.onMouseLeave),
            // Ignore href if Loom is enabled so that it doesn't interfere with recording
            href: isLoomEnabled ? undefined : href,
            disabled: disabled || isDisabled || connectivityMode === 'offline',
            api: api,
            appearance: appearance,
            onClick: (e)=>handleOnClick(e),
            ...restProps
        });
    });
const $e04bd784ac086222$var$LoomToolbarButtonWrapper = ({ disabled: disabled, api: api, appearance: appearance })=>{
    const handleOnClick = (0, $42omo.useCallback)(()=>(0, $a212a932479b4271$export$92a5ff9a4d5c2287)(api), [
        api
    ]);
    const { loomEnabled: loomEnabled, connectivityMode: connectivityMode } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'loom',
        'connectivity'
    ], $e04bd784ac086222$var$selector);
    if (loomEnabled === undefined) return null;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $e0f54c4226daf504$export$2e2bcd8739ae039), {
        // Disable the icon while the SDK isn't initialised
        disabled: disabled || !loomEnabled || connectivityMode === 'offline',
        api: api,
        appearance: appearance,
        onClick: handleOnClick
    });
};
const $e04bd784ac086222$export$b7aa095334bc8677 = (config, api)=>({ disabled: disabled, appearance: appearance })=>{
        if (config.shouldShowToolbarButton === false) return null;
        if (config.renderButton) return config.renderButton($e04bd784ac086222$var$CustomisableLoomToolbarButton(disabled, appearance, api));
        if (config.shouldShowToolbarButton) return /*#__PURE__*/ (0, $9K4OG.jsx)($e04bd784ac086222$var$LoomToolbarButtonWrapper, {
            // Disable the icon while the SDK isn't initialised
            disabled: disabled,
            api: api,
            appearance: appearance
        });
        return null;
    };






parcelRequire("42omo");


var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");


var $6UWPx = parcelRequire("6UWPx");











var $8C5kA = parcelRequire("8C5kA");








var $gzUv9 = parcelRequire("gzUv9");




var $2GVu1 = parcelRequire("2GVu1");


const $6934ba2fbea4b39b$var$useLoomEnabled = (api)=>{
    const { loomEnabled: loomEnabled } = (0, $eiA8Z.useSharedPluginStateWithSelector)(api, [
        'loom'
    ], (states)=>{
        return {
            loomEnabled: states.loomState?.isEnabled
        };
    });
    return loomEnabled;
};
const $6934ba2fbea4b39b$export$cfd738d449e0a4ef = ({ api: api, renderButton: renderButton })=>{
    const loomEnabled = $6934ba2fbea4b39b$var$useLoomEnabled(api);
    if (renderButton) return renderButton($6934ba2fbea4b39b$var$CustomisableLoomMenuItem(api));
    else if (loomEnabled !== undefined) return /*#__PURE__*/ (0, $l998X.jsx)($6934ba2fbea4b39b$var$DefaultLoomMenuItem, {
        api: api
    });
};
const $6934ba2fbea4b39b$var$CustomisableLoomMenuItem = (api)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ isDisabled: isDisabled = false, onClickBeforeInit: onClickBeforeInit, href: href, target: target, rel: rel }, ref)=>{
        const loomEnabled = !!$6934ba2fbea4b39b$var$useLoomEnabled(api);
        const handleOnClick = (0, $42omo.useCallback)((e)=>{
            if (loomEnabled) (0, $a212a932479b4271$export$92a5ff9a4d5c2287)(api);
            else if (onClickBeforeInit && e.type === 'click' && e.target instanceof HTMLElement) onClickBeforeInit(e);
        }, [
            loomEnabled,
            onClickBeforeInit
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)($6934ba2fbea4b39b$var$MenuItemComponent, {
            ref: ref,
            // Ignore href if Loom is enabled so that it doesn't interfere with recording
            href: loomEnabled ? undefined : href,
            disabled: isDisabled,
            onClick: handleOnClick,
            target: target,
            rel: rel
        });
    });
const $6934ba2fbea4b39b$var$DefaultLoomMenuItem = ({ api: api })=>{
    const loomEnabled = $6934ba2fbea4b39b$var$useLoomEnabled(api);
    const handleOnClick = (0, $42omo.useCallback)(()=>(0, $a212a932479b4271$export$92a5ff9a4d5c2287)(api), [
        api
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($6934ba2fbea4b39b$var$MenuItemComponent, {
        disabled: !loomEnabled,
        onClick: handleOnClick
    });
};
const $6934ba2fbea4b39b$var$MenuItemComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(({ disabled: disabled, onClick: onClick, href: href, target: target, rel: rel }, ref)=>{
    const { editorAppearance: editorAppearance } = (0, $gzUv9.useEditorToolbar)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))), {
            size: "small",
            label: ""
        }),
        isDisabled: disabled,
        href: href,
        target: target,
        rel: rel,
        onClick: (e)=>onClick(e),
        children: formatMessage(editorAppearance === 'comment' ? (0, $4HWgE.toolbarInsertBlockMessages).addLoomVideoComment : (0, $4HWgE.toolbarInsertBlockMessages).addLoomVideo)
    });
});





parcelRequire("42omo");





var $b3YrF = parcelRequire("b3YrF");





var $dTb09 = parcelRequire("dTb09");




/**
 * !! When removing platform_editor_toolbar_aifc_patch_3 also remove package dependency on `@atlaskit/editor-plugin-view-mode`.
 */ const $0e0411cca8afc5ea$var$usePluginState = (0, $dTb09.conditionalHooksFactory)(()=>(0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_3', 'isEnabled', true), (api)=>{
    const { editorViewMode: editorViewMode } = (0, $gzUv9.useEditorToolbar)();
    return {
        editorViewMode: editorViewMode
    };
}, (api)=>{
    const editorViewMode = (0, $b3YrF.useSharedPluginStateSelector)(api, 'editorViewMode.mode');
    return {
        editorViewMode: editorViewMode
    };
});
const $0e0411cca8afc5ea$export$4b1545b4f2016d26 = ({ children: children, api: api })=>{
    const { editorViewMode: editorViewMode } = $0e0411cca8afc5ea$var$usePluginState(api);
    const isEdit = editorViewMode === 'edit';
    if (!isEdit) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6UWPx.ToolbarDropdownItemSection), {
        hasSeparator: isEdit,
        children: children
    });
};


const $cc270d98483e6586$export$a758406ca53b86a5 = (config, api)=>{
    return [
        {
            type: (0, $cPCP8.LOOM_MENU_SECTION).type,
            key: (0, $cPCP8.LOOM_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $cPCP8.OVERFLOW_MENU).type,
                    key: (0, $cPCP8.OVERFLOW_MENU).key,
                    rank: (0, $4Chin.OVERFLOW_MENU_RANK)[(0, $cPCP8.LOOM_MENU_SECTION).key]
                },
                {
                    type: (0, $cPCP8.OVERFLOW_MENU_PRIMARY_TOOLBAR).type,
                    key: (0, $cPCP8.OVERFLOW_MENU_PRIMARY_TOOLBAR).key,
                    rank: (0, $4Chin.OVERFLOW_MENU_PRIMARY_TOOLBAR_RANK)[(0, $cPCP8.LOOM_MENU_SECTION).key]
                }
            ],
            component: ({ children: children })=>{
                if ((0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_3', 'isEnabled', true)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $0e0411cca8afc5ea$export$4b1545b4f2016d26), {
                    api: api,
                    children: children
                });
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $6UWPx.ToolbarDropdownItemSection), {
                    hasSeparator: true,
                    children: children
                });
            }
        },
        {
            type: (0, $cPCP8.LOOM_MENU_ITEM).type,
            key: (0, $cPCP8.LOOM_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $cPCP8.LOOM_MENU_SECTION).type,
                    key: (0, $cPCP8.LOOM_MENU_SECTION).key,
                    rank: (0, $4Chin.LOOM_MENU_SECTION_RANK)[(0, $cPCP8.LOOM_MENU_ITEM).key]
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $6934ba2fbea4b39b$export$cfd738d449e0a4ef), {
                    api: api,
                    renderButton: config.renderButton
                });
            }
        }
    ];
};


const $574aa43e6bff8140$export$c1375d8d7bd75982 = ({ config: config, api: api })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const isNewToolbarEnabled = Boolean(api?.toolbar) && (0, $1oCLl.expValEquals)('platform_editor_toolbar_migrate_loom', 'isEnabled', true);
    // Workaround since we want to insert a loom via the `hyperlink` plugin for now.
    // The hyperlink plugin (and the card plugin) are deeply tied into using the Prosemirror Command
    // Ideally one day we refactor those and we can remove this.
    const editorViewRef = {
        current: null
    };
    const primaryToolbarComponent = (0, $e04bd784ac086222$export$b7aa095334bc8677)(config, api);
    if (isNewToolbarEnabled) api?.toolbar?.actions.registerComponents((0, $cc270d98483e6586$export$a758406ca53b86a5)(config, api));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'loom',
        component: primaryToolbarComponent
    });
    return {
        name: 'loom',
        actions: {
            recordVideo: $a212a932479b4271$export$2d56b03ca3f4ead9,
            insertLoom: (video, positionType)=>(0, $a212a932479b4271$export$e61f2d2bdaa7ecf4)(editorViewRef.current, api, video, positionType),
            initLoom: ({ loomProvider: loomProvider })=>{
                return (0, $a212a932479b4271$export$a39487b0b81d2404)(loomProvider, api, editorViewRef.current, true);
            }
        },
        pmPlugins: ()=>[
                {
                    name: 'loom',
                    plugin: ()=>(0, $ae8edf494757bf0e$export$ae829ec7b2625219)({
                            config: config,
                            api: api
                        })
                },
                {
                    name: 'loomViewRefWorkaround',
                    plugin: ()=>{
                        return new (0, $1S4f7.SafePlugin)({
                            view: (editorView)=>{
                                // Do not cleanup the editorViewRef on destroy
                                // because some functions may point to a stale
                                // reference and this means we will return null.
                                // EditorView is assumed to be stable so we do not need to
                                // cleanup.
                                // See: #hot-106316
                                editorViewRef.current = editorView;
                                return {};
                            }
                        });
                    }
                }
            ],
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $ae8edf494757bf0e$export$db6b5ebe5a8c279).getState(editorState);
        },
        pluginsOptions: {
            // Enable inserting Loom recordings through the slash command
            quickInsert: (intl)=>{
                if (config.loomProvider) return (0, $ad333a3a37885863$export$3432d7b65cad662d)(editorAnalyticsAPI)(intl);
                return [];
            }
        },
        // Enable inserting Loom recordings through main toolbar
        primaryToolbarComponent: !api?.primaryToolbar && !isNewToolbarEnabled ? primaryToolbarComponent : undefined
    };
};
module.exports["loomPlugin"] = $574aa43e6bff8140$export$c1375d8d7bd75982;

});

parcelRegister("cu2RD", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $aptVT = parcelRequire("aptVT");


var $dh538 = parcelRequire("dh538");


var $1oCLl = parcelRequire("1oCLl");


var $iu6m9 = parcelRequire("iu6m9");


var $d925B = parcelRequire("d925B");


var $b167b = parcelRequire("b167b");


var $5qdhe = parcelRequire("5qdhe");


var $1S4f7 = parcelRequire("1S4f7");


var $ks2lK = parcelRequire("ks2lK");








var $7XFGZ = parcelRequire("7XFGZ");

const $3d2494da195881ae$var$getAllUniqueBackgroundColorMarksInRange = (from, to, tr)=>{
    const { doc: doc } = tr;
    const { backgroundColor: backgroundColor } = doc.type.schema.marks;
    const colorMarks = [];
    const colorSet = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (node.isLeaf) {
            const mark = backgroundColor.isInSet(node.marks);
            if (mark && !colorSet.has(mark.attrs.color)) {
                colorMarks.push(mark);
                colorSet.add(mark.attrs.color);
            }
        }
    });
    return colorMarks;
};
const $3d2494da195881ae$var$getAllUniqueBackgroundColorMarksInCellSelection = (selection, tr)=>{
    const colorMarks = [];
    const colorSet = new Set();
    selection.forEachCell((cell, cellPos)=>{
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        const marks = $3d2494da195881ae$var$getAllUniqueBackgroundColorMarksInRange(from, to, tr);
        marks.forEach((mark)=>{
            if (!colorSet.has(mark.attrs.color)) {
                colorMarks.push(mark);
                colorSet.add(mark.attrs.color);
            }
        });
    });
    return colorMarks;
};
// For Cell Selections - find first instance of a backgroundColor mark
// if all cells entirely contain this mark, set the color.
// If the selection contains multiple colors, return null
const $3d2494da195881ae$var$getColorFromCellSelection = (selection, tr)=>{
    const marks = $3d2494da195881ae$var$getAllUniqueBackgroundColorMarksInCellSelection(selection, tr);
    if (marks.length > 1) return 'multiple';
    const firstColorMark = marks.at(0);
    if (!firstColorMark) return null;
    let foundUncolouredNode = false;
    selection.forEachCell((cell, cellPos)=>{
        if (foundUncolouredNode) return;
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        if (!(0, $b167b.entireSelectionContainsMark)(firstColorMark, tr.doc, from, to)) foundUncolouredNode = true;
    });
    return foundUncolouredNode ? null : firstColorMark.attrs.color;
};
// All other selections - find the first instance of a backgroundColor mark
// if selection entirely contains this mark, set the color.
// If the selection contains multiple colors, return null
const $3d2494da195881ae$var$getColorFromRange = (from, to, tr)=>{
    const marks = $3d2494da195881ae$var$getAllUniqueBackgroundColorMarksInRange(from, to, tr);
    if (marks.length > 1) return 'multiple';
    const firstColorMark = marks.at(0);
    if (firstColorMark && (0, $b167b.entireSelectionContainsMark)(firstColorMark, tr.doc, from, to)) return firstColorMark.attrs.color;
    return null;
};
// For Cursor selections - set color if it is found in the storedMarks or $cursor.marks
const $3d2494da195881ae$var$getColorFromCursor = (selection, tr)=>{
    if (!selection.$cursor) return null;
    const mark = tr.doc.type.schema.marks.backgroundColor.isInSet([
        ...tr.storedMarks ? tr.storedMarks : [],
        ...selection.$cursor.marks()
    ]);
    return mark?.attrs.color ?? null;
};
const $3d2494da195881ae$export$1c6fa8f53a5fb47f = (tr)=>{
    const { selection: selection } = tr;
    let color = null;
    if (selection instanceof (0, $7XFGZ.CellSelection)) color = $3d2494da195881ae$var$getColorFromCellSelection(selection, tr);
    else if (selection instanceof (0, $ks2lK.TextSelection) && selection.$cursor) color = $3d2494da195881ae$var$getColorFromCursor(selection, tr);
    else color = $3d2494da195881ae$var$getColorFromRange(selection.from, selection.to, tr);
    return color;
};



var $l6xRR = parcelRequire("l6xRR");


var $adhil = parcelRequire("adhil");




const $7d78cd00df36c4c6$export$4af1020a67b5ec91 = (state)=>{
    const { backgroundColor: backgroundColor } = state.schema.marks;
    const { empty: empty, ranges: ranges, $cursor: $cursor } = state.selection;
    if (!backgroundColor) return true;
    if (state.selection instanceof (0, $ks2lK.NodeSelection) || state.selection instanceof (0, $adhil.GapCursorSelection)) return true;
    if (empty && !$cursor || (0, $l6xRR.isMarkAllowedInRange)(state.doc, ranges, backgroundColor) === false) return true;
    if ((0, $l6xRR.isMarkExcluded)(backgroundColor, state.storedMarks || $cursor && $cursor.marks())) return true;
    return false;
};


const $4d4a1e94f0e796d8$export$b8f1e1e1a4636cb0 = new (0, $ks2lK.PluginKey)('highlight');
var $4d4a1e94f0e796d8$export$2dfab9d4f3f51423 = /*#__PURE__*/ function(HighlightPluginAction) {
    HighlightPluginAction[HighlightPluginAction["CHANGE_COLOR"] = 0] = "CHANGE_COLOR";
    HighlightPluginAction[HighlightPluginAction["SET_PALETTE"] = 1] = "SET_PALETTE";
    return HighlightPluginAction;
}({});
const $4d4a1e94f0e796d8$export$ae829ec7b2625219 = ({ api: api })=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $4d4a1e94f0e796d8$export$b8f1e1e1a4636cb0,
        state: {
            init: (_, editorState)=>({
                    activeColor: null,
                    disabled: (0, $7d78cd00df36c4c6$export$4af1020a67b5ec91)(editorState),
                    isPaletteOpen: false
                }),
            apply: (tr, pluginState, _oldState, newState)=>{
                const action = tr.getMeta($4d4a1e94f0e796d8$export$b8f1e1e1a4636cb0)?.type;
                switch(action){
                    case 0:
                        const { color: color } = tr.getMeta($4d4a1e94f0e796d8$export$b8f1e1e1a4636cb0);
                        return {
                            ...pluginState,
                            activeColor: color
                        };
                    case 1:
                        const { isPaletteOpen: isPaletteOpen } = tr.getMeta($4d4a1e94f0e796d8$export$b8f1e1e1a4636cb0);
                        return {
                            ...pluginState,
                            isPaletteOpen: isPaletteOpen
                        };
                    default:
                        return {
                            ...pluginState,
                            activeColor: (0, $3d2494da195881ae$export$1c6fa8f53a5fb47f)(tr),
                            disabled: (0, $7d78cd00df36c4c6$export$4af1020a67b5ec91)(newState)
                        };
                }
            }
        }
    });
};



const $443070aebdee33c1$export$917538e4f4eb20f9 = (editorAnalyticsAPI)=>({ color: color, inputMethod: inputMethod })=>({ tr: tr })=>{
            const { backgroundColor: backgroundColor } = tr.doc.type.schema.marks;
            if (!backgroundColor) return null;
            editorAnalyticsAPI?.attachAnalyticsEvent($443070aebdee33c1$var$createAnalyticsEvent(color, inputMethod, tr))(tr);
            tr.scrollIntoView();
            if (color === (0, $5qdhe.REMOVE_HIGHLIGHT_COLOR)) (0, $b167b.removeMark)(backgroundColor)({
                tr: tr
            });
            else {
                tr.setMeta((0, $4d4a1e94f0e796d8$export$b8f1e1e1a4636cb0), {
                    type: (0, $4d4a1e94f0e796d8$export$2dfab9d4f3f51423).CHANGE_COLOR,
                    color: color
                });
                (0, $b167b.toggleMark)(backgroundColor, {
                    color: color
                })({
                    tr: tr
                });
            }
            return tr;
        };
const $443070aebdee33c1$var$createAnalyticsEvent = (color, inputMethod, tr)=>{
    const previousColor = (0, $3d2494da195881ae$export$1c6fa8f53a5fb47f)(tr) ?? (0, $5qdhe.REMOVE_HIGHLIGHT_COLOR);
    // get color names from palette
    const newColorFromPalette = (0, $5qdhe.highlightColorPalette).find(({ value: value })=>value === color);
    const previousColorFromPalette = (0, $5qdhe.highlightColorPalette).find(({ value: value })=>value === previousColor);
    const newColorLabel = newColorFromPalette ? newColorFromPalette.label : color;
    const previousColorLabel = previousColorFromPalette ? previousColorFromPalette.label : previousColor;
    return {
        action: (0, $d925B.ACTION).FORMATTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            newColor: newColorLabel.toLowerCase(),
            previousColor: previousColorLabel ? previousColorLabel.toLowerCase() : '',
            inputMethod: inputMethod
        }
    };
};









var $ftzrq = parcelRequire("ftzrq");




const $8bd38b773d7252d2$export$d6f914f85b7b868b = (node)=>{
    return node.isText && node.marks.some((mark)=>mark.type.name === 'backgroundColor');
};
const $8bd38b773d7252d2$export$48e6e6ce50a6fb39 = ({ state: state, nodeStart: nodeStart })=>{
    const $pos = state.doc.resolve(nodeStart);
    const isAtBlockStart = $pos.parentOffset === 0;
    if (isAtBlockStart) return true;
    const isAtDocStart = nodeStart === 0;
    if (isAtDocStart) return true;
    const isPrevCharSpace = state.doc.textBetween(nodeStart - 1, nodeStart) === ' ';
    if (isPrevCharSpace) return true;
    return false;
};
const $8bd38b773d7252d2$export$b44b3045e621df46 = ({ state: state, nodeEnd: nodeEnd })=>{
    const $pos = state.doc.resolve(nodeEnd);
    const isAtBlockEnd = $pos.parentOffset === $pos.parent.content.size;
    if (isAtBlockEnd) return true;
    const isAtDocEnd = nodeEnd === state.doc.content.size;
    if (isAtDocEnd) return true;
    const isNextCharSpace = state.doc.textBetween(nodeEnd, nodeEnd + 1) === ' ';
    if (isNextCharSpace) return true;
    return false;
};


const $75d65e7fd63930f1$var$createPaddingDecoration = ({ pos: pos, node: node, padLeft: padLeft, padRight: padRight })=>{
    const classes = [];
    const baseClass = 'background-color';
    const padLeftClass = `${baseClass}-padding-left`;
    const padRightClass = `${baseClass}-padding-right`;
    if (padLeft) classes.push(padLeftClass);
    if (padRight) classes.push(padRightClass);
    return (0, $ftzrq.Decoration).inline(pos, pos + node.nodeSize, {
        class: classes.join(' ')
    });
};
const $75d65e7fd63930f1$export$e955b6e659e59713 = ({ decorationSet: decorationSet, state: state, from: from, to: to })=>{
    let newDecorationSet = decorationSet;
    state.doc.nodesBetween(from, to, (node, pos)=>{
        if (!(0, $8bd38b773d7252d2$export$d6f914f85b7b868b)(node)) return;
        const nodeStart = pos;
        const nodeEnd = pos + node.nodeSize;
        const padLeft = (0, $8bd38b773d7252d2$export$48e6e6ce50a6fb39)({
            state: state,
            nodeStart: nodeStart
        });
        const padRight = (0, $8bd38b773d7252d2$export$b44b3045e621df46)({
            state: state,
            nodeEnd: nodeEnd
        });
        if (padLeft && padRight) {
            const newDecoration = $75d65e7fd63930f1$var$createPaddingDecoration({
                pos: nodeStart,
                node: node,
                padLeft: padLeft,
                padRight: padRight
            });
            newDecorationSet = newDecorationSet.add(state.doc, [
                newDecoration
            ]);
        }
    });
    return newDecorationSet;
};



const $8934f79a1793d309$export$d9003f1f8089aa99 = ({ decorationSet: prevDecorationSet, state: state, start: start, end: end })=>{
    // First remove any decorations within the range
    // Note that it finds all decorations in the set which touch the given range (including decorations that start or end directly at the boundaries)
    const toRemove = prevDecorationSet.find(start, end);
    const decorationSet = prevDecorationSet.remove(toRemove);
    // Expand the range by 1 on each side to catch adjacent text nodes
    // that may need padding decorations added/removed
    const from = Math.max(0, start - 1);
    const to = Math.min(state.doc.content.size, end + 1);
    return (0, $75d65e7fd63930f1$export$e955b6e659e59713)({
        decorationSet: decorationSet,
        state: state,
        from: from,
        to: to
    });
};


const $9cdc59158e6be17c$export$64079c8b271eeba4 = new (0, $ks2lK.PluginKey)('highlightPaddingPluginKey');
const $9cdc59158e6be17c$export$8d5a971433249768 = ()=>{
    return new (0, $1S4f7.SafePlugin)({
        key: $9cdc59158e6be17c$export$64079c8b271eeba4,
        state: {
            init: (_, state)=>{
                // Initially scan the entire doc to create all highlight padding decorations
                // after which updates will only apply to changed ranges
                const initialDecorationSet = (0, $ftzrq.DecorationSet).empty;
                const decorationSet = (0, $75d65e7fd63930f1$export$e955b6e659e59713)({
                    decorationSet: initialDecorationSet,
                    state: state,
                    from: 0,
                    to: state.doc.content.size
                });
                return {
                    decorationSet: decorationSet
                };
            },
            apply: (tr, pluginState, _oldState, state)=>{
                if (!tr.docChanged) return pluginState;
                let decorationSet = pluginState.decorationSet.map(tr.mapping, tr.doc);
                tr.mapping.maps.forEach((stepMap)=>{
                    stepMap.forEach((_oldStart, _oldEnd, start, end)=>{
                        decorationSet = (0, $8934f79a1793d309$export$d9003f1f8089aa99)({
                            decorationSet: decorationSet,
                            state: state,
                            start: start,
                            end: end
                        });
                    });
                });
                return {
                    decorationSet: decorationSet
                };
            }
        },
        props: {
            decorations: (state)=>{
                return $9cdc59158e6be17c$export$64079c8b271eeba4.getState(state).decorationSet;
            }
        }
    });
};






var $hgeg8 = parcelRequire("hgeg8");

var $60bKU = parcelRequire("60bKU");


var $gmyMu = parcelRequire("gmyMu");












const $0fd746eb53b3bb5e$export$7c9cf3bdfeac3246 = (api)=>({ inputMethod: inputMethod })=>(state, dispatch)=>{
            const isPaletteOpen = (0, $4d4a1e94f0e796d8$export$b8f1e1e1a4636cb0).getState(state)?.isPaletteOpen;
            return $0fd746eb53b3bb5e$export$9567774ece486a9(api)({
                isPaletteOpen: !isPaletteOpen,
                inputMethod: inputMethod
            })(state, dispatch);
        };
const $0fd746eb53b3bb5e$export$9567774ece486a9 = (api)=>({ isPaletteOpen: isPaletteOpen, inputMethod: inputMethod })=>(state, dispatch)=>{
            const isDisabled = (0, $4d4a1e94f0e796d8$export$b8f1e1e1a4636cb0).getState(state)?.disabled;
            if (!isDisabled) {
                const tr = state.tr;
                tr.setMeta((0, $4d4a1e94f0e796d8$export$b8f1e1e1a4636cb0), {
                    type: (0, $4d4a1e94f0e796d8$export$2dfab9d4f3f51423).SET_PALETTE,
                    isPaletteOpen: isPaletteOpen
                });
                api.analytics?.actions.attachAnalyticsEvent($0fd746eb53b3bb5e$var$createAnalyticsEvent(isPaletteOpen, inputMethod))(tr);
                tr.setMeta('addToHistory', false);
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
const $0fd746eb53b3bb5e$var$createAnalyticsEvent = (isPaletteOpen, inputMethod)=>{
    return {
        action: isPaletteOpen ? (0, $d925B.ACTION).OPENED : (0, $d925B.ACTION).CLOSED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TOOLBAR,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: inputMethod
        }
    };
};


function $37cb423ae71dbe77$export$e832373cff8dec22({ api: api }) {
    const list = {};
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    if (!(isToolbarAIFCEnabled && (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_6', 'isEnabled', true))) (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.toggleHighlightPalette).common, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $0fd746eb53b3bb5e$export$7c9cf3bdfeac3246)(api)({
        inputMethod: (0, $d925B.INPUT_METHOD).SHORTCUT
    }), list);
    const analyticsApi = api?.analytics?.actions;
    const color = (0, $1oCLl.expValEquals)('platform_editor_add_orange_highlight_color', 'cohort', 'test') ? (0, $5qdhe.highlightColorPaletteNext).find(({ label: label })=>label === 'Yellow') : (0, $5qdhe.highlightColorPalette).find(({ label: label })=>label === 'Yellow') || {
        value: '#fedec8'
    };
    if (color) (0, $hgeg8.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hgeg8.applyYellowHighlight).common, (0, $gmyMu.editorCommandToPMCommand)((0, $443070aebdee33c1$export$917538e4f4eb20f9)(analyticsApi)({
        color: color.value,
        inputMethod: (0, $d925B.INPUT_METHOD).SHORTCUT
    })), list);
    return (0, $60bKU.keymap)(list);
}



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $gmMgo = parcelRequire("gmMgo");





var $eiA8Z = parcelRequire("eiA8Z");


var $cQMhV = parcelRequire("cQMhV");





var $e0nFU = parcelRequire("e0nFU");


var $cORDs = parcelRequire("cORDs");

var $iMS6j = parcelRequire("iMS6j");


var $8TW6I = parcelRequire("8TW6I");

var $a4eZN = parcelRequire("a4eZN");


var $bWiTS = parcelRequire("bWiTS");


var $74Ajl = parcelRequire("74Ajl");


var $7kzZ3 = parcelRequire("7kzZ3");











parcelRequire("42omo");





var $eCikN = parcelRequire("eCikN");


var $gdv5Z = parcelRequire("gdv5Z");

const $f5d7eaf6c13435d2$export$341b4cabd7cbb2ea = ({ disabled: disabled, selectedColor: selectedColor })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        paddingInline: "space.050",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cQMhV.SteppedRainbowIconDecoration), {
            selectedColor: selectedColor,
            disabled: disabled,
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eCikN))), {
                LEGACY_size: "small",
                label: ""
            })
        })
    });





parcelRequire("42omo");


var $hxEux = parcelRequire("hxEux");

var $fWSjz = parcelRequire("fWSjz");

var $ahQKW = parcelRequire("ahQKW");




var $5v8Ta = parcelRequire("5v8Ta");

var $2dkHo = parcelRequire("2dkHo");





var $aFUXX = parcelRequire("aFUXX");




const $c17a292014f8c899$var$HIGHLIGHT_COLOR_PICKER_COLUMNS = 8;
const $c17a292014f8c899$export$780f86860853be18 = (props)=>{
    const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isOpen: isOpen, activeColor: activeColor, trigger: trigger, onColorChange: onColorChange, isOpenedByKeyboard: isOpenedByKeyboard, handleClickOutside: handleClickOutside, handleEscapeKeydown: handleEscapeKeydown } = props;
    const isOrangeHighlightEnabled = (0, $1oCLl.expValEquals)('platform_editor_add_orange_highlight_color', 'cohort', 'test');
    // pixels, used to determine where to horizontally position the dropdown when space is limited
    // this should reflect the width of the dropdown when fully populated with colors, including translations due to layering
    const fitWidth = isOrangeHighlightEnabled ? 274 : 242;
    let colorPalette;
    if (isOrangeHighlightEnabled) colorPalette = (0, $5qdhe.highlightColorPaletteNext);
    else colorPalette = (0, $5qdhe.highlightColorPalette).map((item)=>{
        if (item.label === 'Orange') return {
            ...item,
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            label: 'Yellow',
            message: (0, $fWSjz.default).yellow
        };
        return item;
    });
    const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = (0, $ahQKW.getSelectedRowAndColumnFromPalette)(colorPalette, activeColor, isOrangeHighlightEnabled ? $c17a292014f8c899$var$HIGHLIGHT_COLOR_PICKER_COLUMNS : undefined);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2dkHo.DropdownContainer), {
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        isOpen: isOpen,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleEscapeKeydown,
        zIndex: (0, $aFUXX.akEditorMenuZIndex),
        fitWidth: fitWidth,
        closeOnTab: true,
        arrowKeyNavigationProviderOptions: {
            type: (0, $5v8Ta.ArrowKeyNavigationType).COLOR,
            selectedRowIndex: selectedRowIndex,
            selectedColumnIndex: selectedColumnIndex,
            isOpenedByKeyboard: isOpenedByKeyboard,
            isPopupPositioned: true
        },
        trigger: trigger,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            "data-testid": "highlight-color-palette",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hxEux.default), {
                cols: isOrangeHighlightEnabled ? $c17a292014f8c899$var$HIGHLIGHT_COLOR_PICKER_COLUMNS : undefined,
                onClick: onColorChange,
                selectedColor: activeColor,
                paletteOptions: {
                    palette: colorPalette,
                    hexToPaletteColor: (0, $bWiTS.hexToEditorTextBackgroundPaletteColor)
                }
            })
        })
    });
};






const $86014c52cbaafb4d$export$98f4eb06acf89919 = (args)=>{
    const { toolbarItemRef: toolbarItemRef, setIsDropdownOpen: setIsDropdownOpen, isDropdownOpen: isDropdownOpen, pluginInjectionApi: pluginInjectionApi } = args;
    const [isOpenedByKeyboard, setIsOpenedByKeyboard] = (0, $42omo.useState)(false);
    return {
        handleClick: ()=>{
            setIsOpenedByKeyboard(false);
            setIsDropdownOpen(!isDropdownOpen);
        },
        handleKeyDown: (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                setIsOpenedByKeyboard(true);
                setIsDropdownOpen(!isDropdownOpen);
            }
        },
        handleClickOutside: ()=>{
            if (isDropdownOpen) {
                setIsDropdownOpen(false);
                setIsOpenedByKeyboard(false);
            }
        },
        handleEscapeKeydown: ()=>{
            if (isDropdownOpen) {
                setIsDropdownOpen(false);
                setIsOpenedByKeyboard(false);
                toolbarItemRef?.current?.focus();
            }
        },
        handleColorChange: ({ color: color, inputMethod: inputMethod })=>{
            pluginInjectionApi?.core?.actions.execute((0, $443070aebdee33c1$export$917538e4f4eb20f9)(pluginInjectionApi?.analytics?.actions)({
                color: color,
                inputMethod: inputMethod
            }));
            setIsDropdownOpen(false);
        },
        isOpenedByKeyboard: isOpenedByKeyboard
    };
};


function $5945e95d36a07c01$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5945e95d36a07c01$var$expandIconContainerHighlightStyle = /*#__PURE__*/ (0, $9K4OG.css)({
    margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
});
const $5945e95d36a07c01$var$highlightIconContainerStyle = {
    name: "1er0evb",
    styles: "margin-top:var(--ds-space-negative-050, -4px)"
};
const $5945e95d36a07c01$var$selector = (states)=>{
    return {
        isPaletteOpen: states.highlightState?.isPaletteOpen,
        activeColor: states.highlightState?.activeColor,
        disabled: states.highlightState?.disabled
    };
};
const $5945e95d36a07c01$var$FloatingToolbarHighlightColor = ({ pluginInjectionApi: pluginInjectionApi, intl: { formatMessage: formatMessage }, editorView: editorView })=>{
    const toolbarItemRef = (0, $42omo.useRef)(null);
    const { activeColor: activeColor, disabled: disabled, isPaletteOpen: isPaletteOpen } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'highlight'
    ], $5945e95d36a07c01$var$selector);
    const setDropdownOpen = (isOpen)=>{
        if (!disabled && editorView && pluginInjectionApi) {
            const { state: state, dispatch: dispatch } = editorView;
            (0, $0fd746eb53b3bb5e$export$9567774ece486a9)(pluginInjectionApi)({
                isPaletteOpen: isOpen,
                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
            })(state, dispatch);
        }
        pluginInjectionApi?.analytics?.actions.fireAnalyticsEvent({
            action: isOpen ? (0, $d925B.ACTION).OPENED : (0, $d925B.ACTION).CLOSED,
            actionSubject: (0, $d925B.ACTION_SUBJECT).TOOLBAR,
            actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR,
            eventType: (0, $d925B.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
            }
        });
    };
    const isDropdownOpen = !!isPaletteOpen;
    const { handleClick: handleClick, handleKeyDown: handleKeyDown, handleClickOutside: handleClickOutside, handleEscapeKeydown: handleEscapeKeydown, handleColorChange: handleColorChange, isOpenedByKeyboard: isOpenedByKeyboard } = (0, $86014c52cbaafb4d$export$98f4eb06acf89919)({
        toolbarItemRef: toolbarItemRef,
        setIsDropdownOpen: setDropdownOpen,
        isDropdownOpen: isDropdownOpen,
        pluginInjectionApi: pluginInjectionApi
    });
    // Don't render the toolbar option while the plugin is initialising
    if (activeColor === undefined || disabled === undefined) return null;
    const toolbarButtonLabel = formatMessage((0, $e0nFU.highlightMessages).highlight);
    // Get the design token for the  active color (if it exists) to modify the toolbar
    // icon, but show the nice rainbow if none is selected
    const activeColorToken = activeColor === null ? null : (0, $bWiTS.hexToEditorTextBackgroundPaletteColor)(activeColor);
    const title = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $hgeg8.tooltip)((0, $hgeg8.toggleHighlightPalette), toolbarButtonLabel) : toolbarButtonLabel;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $c17a292014f8c899$export$780f86860853be18), {
        isOpen: isDropdownOpen && !disabled,
        activeColor: activeColor,
        trigger: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values
            css: (0, $cORDs.disableBlueBorderStyles),
            buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).BACKGROUND_COLOR,
            spacing: (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? 'default' : 'compact',
            disabled: disabled,
            selected: isDropdownOpen,
            "aria-label": title,
            "aria-keyshortcuts": (0, $hgeg8.getAriaKeyshortcuts)((0, $hgeg8.toggleHighlightPalette)),
            "aria-expanded": isDropdownOpen,
            "aria-haspopup": true,
            title: title,
            onClick: handleClick,
            onKeyDown: handleKeyDown,
            ref: toolbarItemRef,
            iconBefore: (0, $dh538.fg)('platform-visual-refresh-icons') ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                css: (0, $cORDs.triggerWrapperStylesWithPadding)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $cQMhV.DynamicStrokeIconDecoration), {
                selectedColor: activeColorToken,
                disabled: disabled,
                icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($74Ajl))), {
                    label: "",
                    color: "currentColor",
                    spacing: "spacious"
                })
            }), // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                css: (0, $iMS6j.expandIconContainerStyle)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7kzZ3))), {
                label: "",
                color: "currentColor",
                size: "small"
            }))) : /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                css: $5945e95d36a07c01$var$highlightIconContainerStyle
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $f5d7eaf6c13435d2$export$341b4cabd7cbb2ea), {
                selectedColor: activeColorToken,
                disabled: disabled
            })),
            iconAfter: (0, $dh538.fg)('platform-visual-refresh-icons') ? undefined : /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                css: $5945e95d36a07c01$var$expandIconContainerHighlightStyle
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7kzZ3))), {
                label: "",
                color: "currentColor",
                size: "small"
            }))
        }, (0, $iu6m9.editorExperiment)('platform_editor_controls', 'control') && formatMessage((0, $e0nFU.highlightMessages).highlightFloatingToolbar)),
        onColorChange: (color)=>handleColorChange({
                color: color,
                inputMethod: (0, $d925B.INPUT_METHOD).FLOATING_TB
            }),
        isOpenedByKeyboard: isOpenedByKeyboard,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleEscapeKeydown
    });
};
const $5945e95d36a07c01$export$5d201a8e1b725031 = (0, $gmMgo.default)($5945e95d36a07c01$var$FloatingToolbarHighlightColor);


/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 














































var $1s5hv = parcelRequire("1s5hv");





const $9f842e0a01a1e3bc$var$selector = (states)=>{
    return {
        isPaletteOpen: states.highlightState?.isPaletteOpen,
        highlightDisabled: states.highlightState?.disabled,
        activeColor: states.highlightState?.activeColor
    };
};
const $9f842e0a01a1e3bc$var$PrimaryToolbarHighlightColor = ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, disabled: disabled, pluginInjectionApi: pluginInjectionApi, intl: { formatMessage: formatMessage }, editorView: editorView })=>{
    const toolbarItemRef = (0, $42omo.useRef)(null);
    const { isPaletteOpen: isPaletteOpen, highlightDisabled: highlightDisabled, activeColor: activeColor } = (0, $eiA8Z.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'highlight'
    ], $9f842e0a01a1e3bc$var$selector);
    const setIsDropdownOpen = (isOpen)=>{
        if (!highlightDisabled) {
            const { state: state, dispatch: dispatch } = editorView;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $0fd746eb53b3bb5e$export$9567774ece486a9)(pluginInjectionApi)({
                isPaletteOpen: isOpen,
                inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR
            })(state, dispatch);
        }
    };
    const isDropdownOpen = !!isPaletteOpen;
    const { handleClick: handleClick, handleKeyDown: handleKeyDown, handleClickOutside: handleClickOutside, handleEscapeKeydown: handleEscapeKeydown, handleColorChange: handleColorChange, isOpenedByKeyboard: isOpenedByKeyboard } = (0, $86014c52cbaafb4d$export$98f4eb06acf89919)({
        toolbarItemRef: toolbarItemRef,
        setIsDropdownOpen: setIsDropdownOpen,
        isDropdownOpen: isDropdownOpen,
        pluginInjectionApi: pluginInjectionApi
    });
    // Don't render the toolbar option while the plugin is initialising
    if (activeColor === undefined || highlightDisabled === undefined) return null;
    const toolbarButtonLabel = formatMessage((0, $e0nFU.highlightMessages).highlight);
    // Get the design token for the  active color (if it exists) to modify the toolbar
    // icon, but show the nice rainbow if none is selected
    const activeColorToken = activeColor === null ? null : (0, $bWiTS.hexToEditorTextBackgroundPaletteColor)(activeColor);
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1s5hv.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $c17a292014f8c899$export$780f86860853be18), {
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        isOpen: isDropdownOpen && !highlightDisabled,
        activeColor: activeColor,
        trigger: /*#__PURE__*/ (0, $9K4OG.jsx)((0, $a4eZN.default), {
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values
            css: (0, $cORDs.disableBlueBorderStyles),
            buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).BACKGROUND_COLOR,
            spacing: isToolbarReducedSpacing ? 'none' : 'default',
            disabled: disabled || highlightDisabled,
            selected: isDropdownOpen,
            "aria-label": (0, $hgeg8.tooltip)((0, $hgeg8.toggleHighlightPalette), toolbarButtonLabel),
            "aria-keyshortcuts": (0, $hgeg8.getAriaKeyshortcuts)((0, $hgeg8.toggleHighlightPalette)),
            "aria-expanded": isDropdownOpen,
            "aria-haspopup": true,
            title: (0, $hgeg8.tooltip)((0, $hgeg8.toggleHighlightPalette), toolbarButtonLabel),
            onClick: handleClick,
            onKeyDown: handleKeyDown,
            ref: toolbarItemRef,
            iconBefore: (0, $dh538.fg)('platform-visual-refresh-icons') ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
                css: (0, $cORDs.triggerWrapperStylesWithPadding)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $cQMhV.DynamicStrokeIconDecoration), {
                selectedColor: activeColorToken,
                disabled: highlightDisabled,
                icon: /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($74Ajl))), {
                    label: "",
                    color: "currentColor",
                    spacing: "spacious"
                })
            }), //eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                css: (0, $iMS6j.expandIconContainerStyle)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7kzZ3))), {
                label: "",
                color: "currentColor",
                size: "small"
            }))) : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $1s5hv.default), null, /*#__PURE__*/ (0, $9K4OG.jsx)((0, $f5d7eaf6c13435d2$export$341b4cabd7cbb2ea), {
                selectedColor: activeColorToken,
                disabled: highlightDisabled
            }), /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $iMS6j.expandIconWrapperStyle)
            }, /*#__PURE__*/ (0, $9K4OG.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7kzZ3))), {
                label: "",
                size: "small"
            })))
        }),
        onColorChange: (color)=>handleColorChange({
                color: color,
                inputMethod: (0, $d925B.INPUT_METHOD).TOOLBAR
            }),
        isOpenedByKeyboard: isOpenedByKeyboard,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleEscapeKeydown
    }));
};
const $9f842e0a01a1e3bc$export$124ac7b23aa1ea6a = (0, $gmMgo.default)($9f842e0a01a1e3bc$var$PrimaryToolbarHighlightColor);





parcelRequire("42omo");


var $cPCP8 = parcelRequire("cPCP8");

var $4Chin = parcelRequire("4Chin");

/* HighlightColorMenuItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");





var $4Dsx2 = parcelRequire("4Dsx2");





var $b3YrF = parcelRequire("b3YrF");





var $g66hv = parcelRequire("g66hv");

var $5v3PK = parcelRequire("5v3PK");


var $7hXDW = parcelRequire("7hXDW");


var $aymRb = parcelRequire("aymRb");


var $5gydP = parcelRequire("5gydP");




var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");




const $c3912d4eed8d6b1c$var$styles = {
    container: "_zulp12x7 _19pkpxbi",
    removeHighlightButton: "_2rko12b0 _195gv77o _189ee4h9 _1dqonqa1 _1h6d1l7x",
    icon: "_1e0c1o8l _18u01n1a"
};
const $c3912d4eed8d6b1c$var$TextColorIconDecorator = ({ label: label, isSelected: isSelected })=>{
    const iconColor = "var(--ds-icon, #292A2E)";
    return isSelected ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aymRb))), {
        color: iconColor,
        LEGACY_primaryColor: iconColor,
        label: label
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "span",
        xcss: $c3912d4eed8d6b1c$var$styles.icon,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5gydP))), {
            label: label,
            color: iconColor,
            shouldRecommendSmallIcon: true,
            spacing: "spacious",
            size: "small"
        })
    });
};
function $c3912d4eed8d6b1c$export$5b2f3a4c271f0961({ api: api, parents: parents }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const activeColor = (0, $b3YrF.useSharedPluginStateSelector)(api, 'highlight.activeColor');
    const context = (0, $5v3PK.useToolbarDropdownMenu)();
    const closeMenu = context?.closeMenu;
    const handleHighlightColorChange = (0, $42omo.useCallback)((color)=>{
        if (api?.highlight?.commands?.changeColor) {
            api.core.actions.execute(api.highlight.commands.changeColor({
                color: color,
                inputMethod: (0, $4Dsx2.getInputMethodFromParentKeys)(parents)
            }));
            closeMenu?.();
        }
    }, [
        api,
        closeMenu,
        parents
    ]);
    const colorPalette = (0, $42omo.useMemo)(()=>{
        const isSelected = (color)=>color.value === activeColor;
        return (0, $5qdhe.highlightColorPaletteNext).filter((color)=>color.value !== (0, $5qdhe.REMOVE_HIGHLIGHT_COLOR)).map((color)=>({
                ...color,
                decorator: /*#__PURE__*/ (0, $l998X.jsx)($c3912d4eed8d6b1c$var$TextColorIconDecorator, {
                    label: color.label,
                    isSelected: isSelected(color)
                })
            }));
    }, [
        activeColor
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        xcss: $c3912d4eed8d6b1c$var$styles.container,
        testId: "highlight-color-menu-item",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                size: "xxsmall",
                children: formatMessage((0, $e0nFU.highlightMessages).highlight)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $g66hv.default), {
                onClick: (color)=>{
                    handleHighlightColorChange(color);
                },
                selectedColor: activeColor || null,
                paletteOptions: {
                    palette: colorPalette || [],
                    hexToPaletteColor: (0, $bWiTS.hexToEditorTextBackgroundPaletteColor)
                }
            }),
            (0, $1oCLl.expValEquals)('platform_editor_toolbar_aifc_patch_4', 'isEnabled', true) ? undefined : /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $c3912d4eed8d6b1c$var$styles.removeHighlightButton
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    shouldFitContainer: true,
                    appearance: "subtle",
                    onClick: ()=>handleHighlightColorChange((0, $5qdhe.REMOVE_HIGHLIGHT_COLOR)),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        weight: "medium",
                        children: "Remove highlight"
                    })
                })
            })
        ]
    });
}


const $a5b7313ece327a81$export$6cd8b101843de8d2 = (api)=>{
    return [
        {
            ...(0, $cPCP8.HIGHLIGHT_MENU_ITEM),
            parents: [
                {
                    ...(0, $cPCP8.TEXT_COLOR_HIGHLIGHT_MENU_SECTION),
                    rank: (0, $4Chin.TEXT_COLOR_HIGHLIGHT_MENU_SECTION_RANK)[(0, $cPCP8.HIGHLIGHT_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $c3912d4eed8d6b1c$export$5b2f3a4c271f0961), {
                    api: api,
                    parents: parents
                })
        }
    ];
};


const $7ff11d0606ef5fb6$export$8751de4ba1d9a8f9 = ({ api: api, config: options })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, editorView: editorView })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $9f842e0a01a1e3bc$export$124ac7b23aa1ea6a), {
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            disabled: disabled,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            pluginInjectionApi: api,
            editorView: editorView
        });
    };
    if (!isToolbarAIFCEnabled) api?.primaryToolbar?.actions.registerComponent({
        name: 'highlight',
        component: primaryToolbarComponent
    });
    else api?.toolbar?.actions.registerComponents((0, $a5b7313ece327a81$export$6cd8b101843de8d2)(api));
    return {
        name: 'highlight',
        marks () {
            return [
                {
                    name: 'backgroundColor',
                    mark: (0, $aptVT.backgroundColor)
                }
            ];
        },
        commands: {
            changeColor: (0, $443070aebdee33c1$export$917538e4f4eb20f9)(editorAnalyticsAPI)
        },
        pmPlugins: ()=>{
            const plugins = [
                {
                    name: 'highlight',
                    plugin: ()=>(0, $4d4a1e94f0e796d8$export$ae829ec7b2625219)({
                            api: api
                        })
                },
                {
                    name: 'highlightKeymap',
                    plugin: ()=>(0, $37cb423ae71dbe77$export$e832373cff8dec22)({
                            api: api
                        })
                }
            ];
            if ((0, $1oCLl.expValEquals)('platform_editor_text_highlight_padding', 'isEnabled', true)) plugins.push({
                name: 'highlightPadding',
                plugin: ()=>(0, $9cdc59158e6be17c$export$8d5a971433249768)()
            });
            return plugins;
        },
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $4d4a1e94f0e796d8$export$b8f1e1e1a4636cb0).getState(editorState);
        },
        pluginsOptions: !isToolbarAIFCEnabled ? {
            selectionToolbar () {
                const toolbarDocking = (0, $dh538.fg)('platform_editor_use_preferences_plugin') ? api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition : api?.selectionToolbar?.sharedState?.currentState()?.toolbarDocking;
                if (toolbarDocking === 'none' && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarCustom = {
                        type: 'custom',
                        render: (view, _idx, dispatchAnalyticsEvent)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $5945e95d36a07c01$export$5d201a8e1b725031), {
                                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                pluginInjectionApi: api,
                                editorView: view
                            }),
                        fallback: []
                    };
                    const rank = (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? 5 : -9;
                    return {
                        rank: rank,
                        isToolbarAbove: true,
                        items: [
                            toolbarCustom
                        ],
                        pluginName: 'highlight'
                    };
                } else return undefined;
            }
        } : {},
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};
module.exports["highlightPlugin"] = $7ff11d0606ef5fb6$export$8751de4ba1d9a8f9;

});

parcelRegister("jgFdO", function(module, exports) {

var $btNLq = parcelRequire("btNLq");

var $i7Bcn = parcelRequire("i7Bcn");

var $gEb6G = parcelRequire("gEb6G");


var $dh538 = parcelRequire("dh538");


var $dZ8uq = parcelRequire("dZ8uq");


var $7tm9l = parcelRequire("7tm9l");


var $24P9d = parcelRequire("24P9d");


var $5MaNT = parcelRequire("5MaNT");





var $1oCLl = parcelRequire("1oCLl");

const $0b09362160fbf83a$var$codeBlockClassNames = {
    container: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER,
    start: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_START,
    end: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_END,
    contentWrapper: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER,
    content: (0, $5MaNT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
};
const $0b09362160fbf83a$var$MATCH_NEWLINES = new RegExp('\n', 'gu');
const $0b09362160fbf83a$var$getFontSize = ()=>(0, $1oCLl.expValEquals)('cc_editor_ai_content_mode', 'variant', 'test') && (0, $dh538.fg)('platform_editor_content_mode_button_mvp') ? '0.875em' : '0.875rem';
// Based on: `packages/editor/editor-plugin-code-block/src/nodeviews/code-block.ts`
const $0b09362160fbf83a$var$toDOM = (node, formattedAriaLabel, config)=>{
    let totalLineCount = 1;
    node.forEach((node)=>{
        const text = node.text;
        if (text) totalLineCount += (node.text.match($0b09362160fbf83a$var$MATCH_NEWLINES) || []).length;
    });
    const maxDigits = totalLineCount.toString().length;
    const content = node.textContent.split('\n').map((_, i)=>i + 1).join('\n');
    return [
        'pre',
        {
            class: $0b09362160fbf83a$var$codeBlockClassNames.container,
            style: `--lineNumberGutterWidth:${maxDigits}ch;`,
            'data-language': node.attrs.language || ''
        },
        [
            'div',
            {
                class: $0b09362160fbf83a$var$codeBlockClassNames.start,
                contenteditable: 'false'
            }
        ],
        [
            'div',
            {
                class: $0b09362160fbf83a$var$codeBlockClassNames.contentWrapper
            },
            [
                'div',
                {
                    // Based on packages/editor/editor-common/src/styles/shared/code-block.ts
                    // But we can't reuse that class as it adds a ::before that intefers with this approach
                    style: (0, $24P9d.convertToInlineCss)({
                        backgroundColor: "var(--ds-background-neutral, #0515240F)",
                        position: 'relative',
                        width: 'var(--lineNumberGutterWidth, 2rem)',
                        /* top and bottom | left and right */ padding: config.allowCodeFolding ? `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-100, 8px)",
                        flexShrink: 0,
                        fontSize: $0b09362160fbf83a$var$getFontSize(),
                        boxSizing: 'content-box'
                    }),
                    contenteditable: 'false'
                },
                [
                    'div',
                    {
                        class: 'code-block-gutter-pseudo-element',
                        style: (0, $24P9d.convertToInlineCss)({
                            textAlign: 'right',
                            color: "var(--ds-text-subtlest, #6B6E76)",
                            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
                            whiteSpace: 'pre-wrap'
                        }),
                        'data-label': content
                    }
                ]
            ],
            [
                'div',
                {
                    class: $0b09362160fbf83a$var$codeBlockClassNames.content
                },
                [
                    'code',
                    {
                        'data-language': node.attrs.language || '',
                        spellcheck: 'false',
                        'data-testid': 'code-block--code',
                        'aria-label': formattedAriaLabel,
                        ...(0, $dh538.fg)('platform_editor_adf_with_localid') && {
                            'data-local-id': node.attrs.localId
                        }
                    },
                    0
                ]
            ]
        ],
        [
            'div',
            {
                class: $0b09362160fbf83a$var$codeBlockClassNames.end,
                contenteditable: 'false'
            }
        ]
    ];
};
const $0b09362160fbf83a$export$3cf83e71c577e77b = (config)=>{
    return {
        ...(0, $dh538.fg)('platform_editor_adf_with_localid') ? (0, $7tm9l.codeBlockWithLocalId) : (0, $7tm9l.codeBlock),
        toDOM: (node)=>$0b09362160fbf83a$var$toDOM(node, '', config)
    };
};



var $1S4f7 = parcelRequire("1S4f7");


var $ftpVl = parcelRequire("ftpVl");


const $ac8e0ae822b535d4$export$28da8fbeb01202c6 = (props)=>{
    return (0, $ftpVl.withLazyLoading)({
        nodeName: 'codeBlock',
        getNodeViewOptions: ()=>{},
        loader: async ()=>{
            const { getCodeBlockAdvancedNodeView: getCodeBlockAdvancedNodeView } = await (parcelRequire("kwuPE"));
            return (node, view, getPos, _decs, _nodeViewOptions, innerDecorations)=>getCodeBlockAdvancedNodeView(props)(node, view, getPos, innerDecorations);
        }
    });
};



var $ks2lK = parcelRequire("ks2lK");

const $1f2f0f9c198ac88d$export$d4559115ffe0b372 = (view, event)=>{
    const { doc: doc, selection: { $head: $head, $anchor: $anchor }, tr: tr, schema: { nodes: { codeBlock: codeBlock } } } = view.state;
    // Position we want to check (directly after our current position)
    const pos = Math.max($head.pos - 1, 1);
    const isNodeBefore = doc.resolve(pos).nodeBefore?.type === codeBlock;
    const maybeProblematicNode = isNodeBefore ? doc.resolve(pos).nodeBefore : doc.resolve(pos).node();
    if (maybeProblematicNode?.type === codeBlock) {
        const nodeSize = maybeProblematicNode.nodeSize;
        const startPos = isNodeBefore ? pos : $head.pos;
        tr.setSelection((0, $ks2lK.TextSelection).create(doc, $anchor.pos, Math.max(startPos - nodeSize, 0)));
        view.dispatch(tr);
        event.preventDefault();
        return true;
    }
    return false;
};
const $1f2f0f9c198ac88d$export$ba335e235e59f4ed = (view, event)=>{
    const { doc: doc, selection: { $head: $head, $anchor: $anchor }, tr: tr, schema: { nodes: { codeBlock: codeBlock } } } = view.state;
    // Position we want to check (directly after our current position)
    const pos = $head.pos + 1;
    const isNodeAfter = doc.resolve(pos).nodeAfter?.type === codeBlock;
    const maybeProblematicNode = isNodeAfter ? doc.resolve(pos).nodeAfter : doc.resolve(pos).node();
    if (maybeProblematicNode?.type === codeBlock) {
        const nodeSize = maybeProblematicNode.nodeSize;
        const startPos = isNodeAfter ? pos : $head.pos;
        tr.setSelection((0, $ks2lK.TextSelection).create(doc, $anchor.pos, Math.min(startPos + nodeSize, doc.content.size)));
        view.dispatch(tr);
        event.preventDefault();
        return true;
    }
    return false;
};


const $c622eb7762717460$export$ae829ec7b2625219 = (props)=>{
    return new (0, $1S4f7.SafePlugin)({
        props: {
            nodeViews: {
                codeBlock: (0, $ac8e0ae822b535d4$export$28da8fbeb01202c6)(props)
            },
            // Custom selection behaviour to fix issues with codeblocks with Shift + Arrow{Up || Down}
            // These issues are also present in the prosemirror codemirror example and @marijnh suggests to
            // use custom event handlers: https://github.com/ProseMirror/website/issues/83
            handleKeyDown (view, event) {
                if (!(event instanceof KeyboardEvent)) return false;
                if (event.key === 'ArrowUp' && event.shiftKey) return (0, $1f2f0f9c198ac88d$export$d4559115ffe0b372)(view, event);
                else if (event.key === 'ArrowDown' && event.shiftKey) return (0, $1f2f0f9c198ac88d$export$ba335e235e59f4ed)(view, event);
            }
        }
    });
};



var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $d925B = parcelRequire("d925B");


var $eKkkY = parcelRequire("eKkkY");


var $b3YrF = parcelRequire("b3YrF");





var $2GVu1 = parcelRequire("2GVu1");


var $eIlE7 = parcelRequire("eIlE7");

const $bfcf36e8662d2e8c$var$nodeName = 'codeBlock';
const $bfcf36e8662d2e8c$var$CodeBlockMenuItem = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const selection = (0, $b3YrF.useSharedPluginStateSelector)(api, 'selection.selection');
    const isCodeBlockSelected = (0, $42omo.useMemo)(()=>{
        if (!selection) return false;
        if (selection instanceof (0, $ks2lK.NodeSelection)) // Note: we are checking for any type of panel, not just of type infopanel
        return selection.node.type.name === $bfcf36e8662d2e8c$var$nodeName;
        return false;
    }, [
        selection
    ]);
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $d925B.INPUT_METHOD).KEYBOARD : (0, $d925B.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $d925B.INPUT_METHOD).BLOCK_MENU;
        api?.core.actions.execute(api?.blockMenu?.commands.formatNode($bfcf36e8662d2e8c$var$nodeName, {
            inputMethod: inputMethod,
            triggeredFrom: triggeredFrom
        }));
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
        onClick: handleClick,
        isSelected: isCodeBlockSelected,
        elemBefore: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eIlE7))), {
            label: ""
        }),
        children: formatMessage((0, $eKkkY.messages).codeBlock)
    });
};
const $bfcf36e8662d2e8c$export$76cec325b897d60 = (api)=>{
    return ()=>/*#__PURE__*/ (0, $l998X.jsx)($bfcf36e8662d2e8c$var$CodeBlockMenuItem, {
            api: api
        });
};


const $ee26c792ae0f4629$export$a69eee655819c5bd = ({ api: api, config: config })=>{
    if ((0, $dZ8uq.expValEqualsNoExposure)('platform_editor_block_menu', 'isEnabled', true)) api?.blockMenu?.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $btNLq.FORMAT_CODE_BLOCK_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $i7Bcn.FORMAT_MENU_ITEM).key,
                rank: (0, $dh538.fg)('platform_editor_block_menu_format_rank_revised') ? (0, $gEb6G.FORMAT_NESTED_MENU_RANK_REVISED)[(0, $btNLq.FORMAT_CODE_BLOCK_MENU_ITEM).key] : (0, $gEb6G.FORMAT_NESTED_MENU_RANK)[(0, $btNLq.FORMAT_CODE_BLOCK_MENU_ITEM).key]
            },
            component: (0, $bfcf36e8662d2e8c$export$76cec325b897d60)(api)
        }
    ]);
    return {
        name: 'codeBlockAdvanced',
        nodes () {
            return [
                {
                    name: 'codeBlock',
                    node: (0, $0b09362160fbf83a$export$3cf83e71c577e77b)({
                        allowCodeFolding: config?.allowCodeFolding ?? false
                    })
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'codeBlockAdvancedPlugin',
                    plugin: ({ getIntl: getIntl })=>(0, $c622eb7762717460$export$ae829ec7b2625219)({
                            api: api,
                            extensions: config?.extensions ?? [],
                            allowCodeFolding: config?.allowCodeFolding ?? false,
                            getIntl: getIntl
                        })
                }
            ];
        }
    };
};
module.exports["codeBlockAdvancedPlugin"] = $ee26c792ae0f4629$export$a69eee655819c5bd;

});

parcelRegister("kwuPE", function(module, exports) {

let $ef0eb668a87554ab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef0eb668a87554ab$var$load("FOgP0"),
    $ef0eb668a87554ab$var$load("3IEky"),
    $ef0eb668a87554ab$var$load("6XNSn")
]).then(()=>parcelRequire('2SLpl'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("iSJi5", function(module, exports) {
const $087baae06cf8cdc5$export$922d75f514df28b7 = async ({ node: node, getMentionNameDetails: getMentionNameDetails })=>{
    const mentionMapping = {};
    const findMentions = async (node)=>{
        if (node.type.name === 'mention') {
            const mentionNameDetails = await getMentionNameDetails(node.attrs.id);
            if (mentionNameDetails) mentionMapping[node.attrs.id] = mentionNameDetails?.name;
        }
        if (node.content) {
            const promises = [];
            node.content.forEach((child)=>{
                promises.push(findMentions(child));
            });
            await Promise.all(promises);
        }
    };
    await findMentions(node);
    return mentionMapping;
};
module.exports["getMentionMap"] = $087baae06cf8cdc5$export$922d75f514df28b7;

});

parcelRegister("3MD1q", function(module, exports) {

var $8klLr = parcelRequire("8klLr");

function $56d53639f779f5c2$export$46d5228a079b1d3(product) {
    return {
        'X-Product': (0, $8klLr.mapToAssistanceServiceProduct)(product)
    };
}
function $56d53639f779f5c2$export$b3f5e033c954a1b0(experienceId) {
    switch(experienceId){
        case 'ai-mate':
            return {
                'X-Channel-Id': 'editor'
            };
        case 'issue-reformatter':
            return {
                'X-Channel-Id': 'issue-reformatter'
            };
        default:
            return {};
    }
}
module.exports["getXProductHeader"] = $56d53639f779f5c2$export$46d5228a079b1d3;
module.exports["getXChannelIdHeader"] = $56d53639f779f5c2$export$b3f5e033c954a1b0;

});

parcelRegister("8klLr", function(module, exports) {
const $32e1a3aceab10983$export$9611928cf0c457d7 = (product)=>{
    switch(product){
        case 'CONFLUENCE':
            return 'confluence';
        case 'JSW':
            return 'jira-software';
        case 'JWM':
            return 'jira-core';
        case 'JSM':
            return 'jsm';
        case 'JPD':
            return 'jpd';
        case 'ATLAS':
            return 'atlas';
        case 'JIRA_FAMILY':
            return 'jira';
        case 'BITBUCKET':
            return 'bitbucket';
        case 'TRELLO':
            return 'trello';
        case 'ELEVATE':
            return 'elevate';
        case 'RECRUIT':
            return 'recruit';
        case 'MERCURY':
            return 'mercury';
        case 'TOWNSQUARE':
            return 'townsquare';
        case 'ADMINHUB':
            return 'admin-hub';
        default:
            return 'unknown';
    }
};
module.exports["mapToAssistanceServiceProduct"] = $32e1a3aceab10983$export$9611928cf0c457d7;

});

parcelRegister("kuYGt", function(module, exports) {
// Request from Trello to add a single selector for all modal screens
// This is to prevent click events within the Editor AI plugin screens
// from triggering a “close” event hiding the Editor while in edit mode.
// See https://hello.atlassian.net/browse/EDITOR-75
const $5876e00d86eabc1e$export$9df59400d72ad68f = 'ai-modal-screen';
module.exports["AI_MODAL_SCREEN_CLASS"] = $5876e00d86eabc1e$export$9df59400d72ad68f;

});

parcelRegister("40sdH", function(module, exports) {
/* FloatingContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $5zdke = parcelRequire("5zdke");


var $7YjFd = parcelRequire("7YjFd");


var $dh538 = parcelRequire("dh538");

const $09db0abbbd70bd3d$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $09db0abbbd70bd3d$var$PRISM_BORDER_STEP_1 = '#0065FF';
const $09db0abbbd70bd3d$var$PRISM_BORDER_STEP_2 = '#0469FF';
const $09db0abbbd70bd3d$var$PRISM_BORDER_STEP_3 = '#BF63F3';
const $09db0abbbd70bd3d$var$PRISM_BORDER_STEP_4 = '#FFA900';
const $09db0abbbd70bd3d$var$defaultPadding = {
    top: 12,
    bottom: 12,
    left: 12,
    right: 12
}; // ED-20633, DSP-14045: Avoid space tokens for now as space tokens are currently using rem units
// and Safari has a bug where rem is incorrectly calculated when there are
// animations involved
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $09db0abbbd70bd3d$var$prismBorderStyles = null;
const $09db0abbbd70bd3d$var$staticStyles = {
    default: "_16r2w4bv _1s6kw4bv",
    firefox: "_16r21l3w _1s6k1l3w _19h915ob _1ank15ob"
};
const $09db0abbbd70bd3d$var$fireFoxBgPosition = null;
const $09db0abbbd70bd3d$var$rotationAnimation = null;
const $09db0abbbd70bd3d$var$animationStyles = {
    default: "_19oh1jq7 _10881jq7 _kwc0ymdr _joxlymdr _18lgp3kn _zo24p3kn _18f312c5 _evp612c5",
    firefox: "_19oh1nnn _10881nnn _kwc09cwz _joxl9cwz _18lgp3kn _zo24p3kn _18f312c5 _evp612c5 _unfq4jg8 _9nev4jg8"
}; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $09db0abbbd70bd3d$var$constantStyles = null;
const $09db0abbbd70bd3d$var$newConstantStyles = null;
const $09db0abbbd70bd3d$var$maxHeightCSS = null;
const $09db0abbbd70bd3d$var$maxWidthCSS = null;
const $09db0abbbd70bd3d$var$chromelessWidth = {
    width: `calc(100% - ${"var(--ds-space-300, 24px)"})`,
    justifySelf: 'center'
}; /**
    * FocusLock adds a focus trap so that users can keep tabbing through the
    * command palette without leaving it unless when pressing escape or clicking outside.
    * Fix this up when cleaning up editor_a11y_focus_trap_ai.
    */ 
const $09db0abbbd70bd3d$var$GatedFocusLock = ({ children: children })=>{
    const scrollParentRef = (0, $42omo.useRef)();
    const ref = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (ref.current) scrollParentRef.current = (0, $7YjFd.findOverflowScrollParent)(ref.current) || undefined;
    }, []);
    if (!(0, $dh538.fg)('aifc_create_enabled') && (0, $dh538.fg)('editor_a11y_focus_trap_ai')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $5zdke.default), {
        ref: ref,
        noFocusGuards: true,
        returnFocus: {
            preventScroll: true
        },
        whiteList: (activeElement)=>{
            if (activeElement === scrollParentRef.current) return false;
            return true;
        },
        focusOptions: {
            preventScroll: true
        },
        className: (0, $gMc0m.default)([
            "_1bsb1osq"
        ]),
        children: children
    });
    return children;
};
const $09db0abbbd70bd3d$export$4ddaad941c29ad29 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ appearance: appearance, paddingAdjustments: paddingAdjustments, rainbowBorder: rainbowBorder = true, rainbowBorderAnimation: rainbowBorderAnimation, disablePadding: disablePadding, children: children, enableMaxHeight: enableMaxHeight, enableMaxWidth: enableMaxWidth, className: className, style: style, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($09db0abbbd70bd3d$var$GatedFocusLock, {
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            ref: ref,
            className: (0, $gMc0m.default)([
                rainbowBorder && "_2rko1wkh _kqswh2mm _16qsglyw _14mj116d _rfx3116d _aetrb3bt _1kt9b3bt _18postnw _1cs8stnw _1bqq1mrw _1g0v1mrw _z0ai1b4h _1mp41b4h _1qdg1b4h _kfgt1b4h _15l21n1a _1auk1n1a _19do1n1a _qnec1n1a _clh3161g _7dwz161g _32rxt94y _1x88t94y _15l21pry _1peq105o _ta6yglyw",
                $09db0abbbd70bd3d$var$staticStyles[$09db0abbbd70bd3d$var$isFirefox ? 'firefox' : 'default'],
                (0, $dh538.fg)('aifc_create_enabled') ? "_2rko1j6v _16qs130s _1bsb1osq _vchhusvi _bfhk1bhr" : "_2rko1wkh _16qs130s _4t3i1osq _1bsb1osq _vchhusvi _bfhk1bhr _10kl1kw7 _ktt71kw7",
                rainbowBorderAnimation && $09db0abbbd70bd3d$var$animationStyles[$09db0abbbd70bd3d$var$isFirefox ? 'firefox' : 'default'],
                enableMaxHeight && "_c71ldgin",
                enableMaxWidth && "_1bsb1kdj _p12f1kdj _10fp1h6o",
                className
            ]),
            ...rest,
            style: {
                ...style,
                // Apply chromeless width styles inline to ensure precedence over CSS classes for screen components (Discard, NoImprovement, etc.)
                ...appearance === 'chromeless' && (0, $dh538.fg)('aifc_create_enabled') ? $09db0abbbd70bd3d$var$chromelessWidth : null,
                ...disablePadding ? null : paddingAdjustments ? {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                    paddingTop: `${$09db0abbbd70bd3d$var$defaultPadding.top + (paddingAdjustments.top ?? 0)}px`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                    paddingRight: `${$09db0abbbd70bd3d$var$defaultPadding.right + (paddingAdjustments.right ?? 0)}px`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                    paddingBottom: `${$09db0abbbd70bd3d$var$defaultPadding.bottom + (paddingAdjustments.bottom ?? 0)}px`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                    paddingLeft: `${$09db0abbbd70bd3d$var$defaultPadding.left + (paddingAdjustments.left ?? 0)}px`
                } : {
                    padding: `${$09db0abbbd70bd3d$var$defaultPadding.top}px ${$09db0abbbd70bd3d$var$defaultPadding.left}px`
                },
                "--_1c73sk5": (0, $7sObp.default)((0, $dh538.fg)('aifc_create_enabled') ? '1rem' : "var(--ds-radius-large, 8px)"),
                "--_u1fc4r": (0, $7sObp.default)((0, $dh538.fg)('aifc_create_enabled') ? `calc(1rem + 1px)` : `calc(${"var(--ds-radius-large, 8px)"} + 1px)`)
            },
            children: children
        })
    });
});
module.exports["FloatingContainer"] = $09db0abbbd70bd3d$export$4ddaad941c29ad29;

});

parcelRegister("imfiV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dMzWS = parcelRequire("dMzWS");

var $3271ec8cc5d31acc$export$114247090b0aae30 = /*#__PURE__*/ function(Breakpoint) {
    Breakpoint[Breakpoint["SmallChromeless"] = 258] = "SmallChromeless";
    Breakpoint[Breakpoint["Small"] = 320] = "Small";
    Breakpoint[Breakpoint["Large"] = Infinity] = "Large";
    return Breakpoint;
}({});
function $3271ec8cc5d31acc$export$4d88d8cc8b24eb33(smallBreakpoint = 320) {
    const [setElement, { width: width }] = (0, $dMzWS.useElementSize)();
    const breakpoint = width < smallBreakpoint ? smallBreakpoint : Infinity;
    return (0, $42omo.useMemo)(()=>[
            setElement,
            {
                breakpoint: breakpoint,
                isSmall: breakpoint <= smallBreakpoint,
                isLarge: breakpoint > smallBreakpoint
            }
        ], [
        breakpoint,
        setElement,
        smallBreakpoint
    ]);
}
module.exports["Breakpoint"] = $3271ec8cc5d31acc$export$114247090b0aae30;
module.exports["useElementBreakpoints"] = $3271ec8cc5d31acc$export$4d88d8cc8b24eb33;

});

parcelRegister("jHWjW", function(module, exports) {
/* Footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $5nBzc = parcelRequire("5nBzc");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $dMzWS = parcelRequire("dMzWS");

/* FooterAIBrand.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $lAFHW = parcelRequire("lAFHW");






var $iXCQx = parcelRequire("iXCQx");


var $giv7U = parcelRequire("giv7U");

function $6a177a0de5eb3ba4$export$e0578d9df5b50dd4({ appearance: appearance }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        children: [
            appearance !== 'small' && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    size: "small",
                    color: "color.text.subtle",
                    children: formatMessage((0, $giv7U.default).rovoCopyright)
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.RovoIcon), {
                label: formatMessage((0, $giv7U.default).rovoCopyright),
                appearance: "neutral",
                size: "small"
            })
        ]
    });
}


/* FooterDisclaimer.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $8tSmd = parcelRequire("8tSmd");


var $lVBH4 = parcelRequire("lVBH4");





var $auNCB = parcelRequire("auNCB");






/* CustomDisclaimer.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $2Nwuj = parcelRequire("2Nwuj");








var $3gadb = parcelRequire("3gadb");

const $8b239a68aa67d8d0$var$footerInformationStylesUnbounded = null;
const $8b239a68aa67d8d0$var$footerInformationStyles = null;
function $8b239a68aa67d8d0$export$2cebd3bbd14f5ea6({ disclaimer: disclaimer }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1n261g80 _4cvr1h6o",
            "_1ul9idpf _1tke1ejb _1yp21o8v _55c61o8v _tml1azsu _17mnazsu _1bchidpf _1rbcidpf _1npc1b66 _1gic1b66 _1e091b66"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            testId: "custom-disclaimer",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                content: disclaimer.tooltip,
                position: "top",
                children: disclaimer.url ? (0, $dh538.fg)('dst-a11y__replace-anchor-with-link__editor-ai') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                    href: disclaimer.url,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: disclaimer.text
                }) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
                /*#__PURE__*/ (0, $l998X.jsx)("a", {
                    href: disclaimer.url,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: disclaimer.text
                }) : /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    children: disclaimer.text
                })
            })
        })
    });
}


const $4e57ea65134cd5ef$var$linkStyles = {
    default: "_11c81o8v _syazazsu _1053azsu"
};
function $4e57ea65134cd5ef$export$d8e84a6a42a1313b({ disclaimer: disclaimer, appearance: appearance }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return disclaimer ? /*#__PURE__*/ (0, $l998X.jsx)((0, $8b239a68aa67d8d0$export$2cebd3bbd14f5ea6), {
        disclaimer: disclaimer
    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
        space: "space.050",
        alignBlock: "center",
        children: [
            (0, $dh538.fg)('aifc_create_enabled') ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tSmd))), {
                label: formatMessage((0, $giv7U.default).infoIconLabel),
                color: "var(--ds-text-subtle, #505258)",
                LEGACY_size: "small",
                size: "small"
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lVBH4))), {
                label: formatMessage((0, $giv7U.default).infoIconLabel),
                color: "var(--ds-text-subtle, #505258)",
                LEGACY_size: "small",
                size: "small"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
                color: "var(--ds-text-subtle, #505258)",
                href: "https://www.atlassian.com/trust/atlassian-intelligence",
                xcss: $4e57ea65134cd5ef$var$linkStyles.default,
                children: formatMessage((0, $giv7U.default).disclaimerTextUpdated)
            })
        ]
    });
}


// Source: https://www.figma.com/design/2do7MeD1hEmSftXLGER1Xy/AI-Patterns-2024?node-id=82-12683&t=bPIR0f4r8UiwwCr1-4
const $887802c4558e1c09$export$3d1352baed9f774a = {
    medium: 328,
    large: 624
};
const $887802c4558e1c09$export$f859a198decf7af = {
    medium: 300,
    large: 480
};





const $71e6f7e617533af7$var$footerStyles = {
    default: "_zulp1b66 _1e0c1txw _1n261g80 _19bvpxbi _u5f3pxbi _ca0qu2gc _n3tdu2gc _15a5nqa1 _4cvr1h6o _1bah1yb4 _1i531l7x _uwhke4h9"
};
function $71e6f7e617533af7$export$a06f1c675e846f6f({ brand: brand, showDisclaimer: showDisclaimer, disclaimer: disclaimer, showBetaLozenge: showBetaLozenge, showFeedback: showFeedback, feedbackForm: feedbackForm }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [setElement, { width: width }] = (0, $dMzWS.useElementSize)();
    const appearance = (0, $42omo.useMemo)(()=>{
        if (brand === 'atlassian-intelligence') {
            if (width < (0, $887802c4558e1c09$export$3d1352baed9f774a).medium) return 'small';
            if (width < (0, $887802c4558e1c09$export$3d1352baed9f774a).large) return 'medium';
            return 'large';
        } else {
            if (width < (0, $887802c4558e1c09$export$f859a198decf7af).medium) return 'small';
            if (width < (0, $887802c4558e1c09$export$f859a198decf7af).large) return 'medium';
            return 'large';
        }
    }, [
        width,
        brand
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        ref: setElement,
        xcss: $71e6f7e617533af7$var$footerStyles.default,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.050",
                children: [
                    showBetaLozenge && /*#__PURE__*/ (0, $l998X.jsx)((0, $5nBzc.default), {
                        testId: "beta-lozenge",
                        children: formatMessage((0, $giv7U.default).betaLabel)
                    }),
                    showDisclaimer ? /*#__PURE__*/ (0, $l998X.jsx)((0, $4e57ea65134cd5ef$export$d8e84a6a42a1313b), {
                        disclaimer: disclaimer,
                        appearance: appearance
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {})
                ]
            }),
            !(0, $dh538.fg)('ai-smart-button-team-25') && !(0, $dh538.fg)('aifc_create_enabled') && !showFeedback && /*#__PURE__*/ (0, $l998X.jsx)((0, $6a177a0de5eb3ba4$export$e0578d9df5b50dd4), {
                brand: brand,
                appearance: appearance
            }),
            showFeedback && /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                        children: formatMessage((0, $giv7U.default).compactFeedbackText)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                        children: feedbackForm
                    })
                ]
            })
        ]
    });
}
module.exports["Footer"] = $71e6f7e617533af7$export$a06f1c675e846f6f;

});

parcelRegister("giv7U", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fe1157c18e790dc$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $1fe1157c18e790dc$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    betaLabel: {
        id: "fabric.editor.ai.screens.preview.betaLabel",
        defaultMessage: "Beta"
    },
    infoIconLabel: {
        id: "fabric.editor.ai.commandPalette.footer.infoIconLabel",
        defaultMessage: "Information"
    },
    atlassianIntelligenceCopyrightShort: {
        id: "fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort",
        defaultMessage: "Powered by AI"
    },
    atlassianIntelligenceCopyright: {
        id: "fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright",
        defaultMessage: "Powered by Atlassian Intelligence"
    },
    rovoCopyright: {
        id: "fabric.editor.ai.commandPalette.footer.rovoCopyright",
        defaultMessage: "Rovo"
    },
    /**
   * https://hello.atlassian.net/wiki/spaces/AAI/pages/5055352099/Footer+guidelines+for+AI+Updated+Mar+2025
   * Updated Mar 2025
   * However this is put behind a feature flag along with a11y updates.
   * Can use this as a default once the feature flag is removed, make sure to get rid of disclaimerTextShort & disclaimerText
   * See thread: https://atlassian.slack.com/archives/C04039CJ003/p1743571543775729
   */ disclaimerTextUpdated: {
        id: "fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated",
        defaultMessage: "Uses AI. Verify results."
    },
    usePageKnowledgeToggleLabel: {
        id: "fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel",
        defaultMessage: "Include knowledge from current page"
    },
    compactFeedbackText: {
        id: "fabric.editor.ai.screens.preview.compactFeedbackText",
        defaultMessage: "Helpful?"
    }
});

});

parcelRegister("8PgnR", function(module, exports) {
/* LatestPromptHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * Note: If deleting this file please also delete the exceptions in this file:
 * `packages/editor/generative-ai-modal/src/ui/screens/Preview/__tests__/vr-tests/Preview.vr.ts`
 * ```ts
 * a11y: {
 *	skip: true,
 * },
 * ```
 *
 * These exceptions were made because we have nested buttons inside the EditPrompt button which is a violation.
 * However, we expect these will be resolved with the completion of this work:
 * https://home.atlassian.com/o/2346a038-3c8c-498b-a79b-e7847859868d/s/a436116f-02ce-4520-8fbb-7301462a1674/project/ATLAS-96926/updates
 */ /** @jsxFrag */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");


var $9LxGu = parcelRequire("9LxGu");


var $9q1Mo = parcelRequire("9q1Mo");

/* ClosePreviewIconButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");





var $cgtv4 = parcelRequire("cgtv4");

var $5c9ff14148143af2$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    closePreviewLabel: {
        id: "fabric.editor.ai.components.closePreviewIconButton.closePreviewLabel.non-final",
        defaultMessage: "Close preview"
    }
});


const $75921729b8ea3338$var$inPromptHeaderStyles = {
    default: "_1e0c116y _2hwx1b66"
};
const $75921729b8ea3338$var$toolTipProps = {
    position: 'top'
};
const $75921729b8ea3338$export$d428cfd0d6a2b2ec = 'close-preview-icon-button';
const $75921729b8ea3338$export$777abcc87b2abd7a = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        xcss: $75921729b8ea3338$var$inPromptHeaderStyles.default,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
            label: formatMessage((0, $5c9ff14148143af2$export$2e2bcd8739ae039).closePreviewLabel),
            spacing: "compact",
            onClick: onClick,
            testId: $75921729b8ea3338$export$d428cfd0d6a2b2ec,
            tooltip: $75921729b8ea3338$var$toolTipProps,
            isTooltipDisabled: false
        })
    });
};


/* EditPromptHoverTag.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 












var $ho4zm = parcelRequire("ho4zm");




const $3a77c66a57ad2118$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    editPromptHover: {
        id: "fabric.editor.ai.screens.preview.header.edit.hover",
        defaultMessage: "Edit"
    },
    clearPromptHover: {
        id: "fabric.editor.ai.screens.preview.header.clear.hover",
        defaultMessage: "Clear"
    }
});


const $414d03f659b34c15$var$containerStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $414d03f659b34c15$var$containerStylesUnbounded = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $414d03f659b34c15$var$placeholderStyles = null;
const $414d03f659b34c15$export$3a1fe5569d8f8994 = ({ isClearMode: isClearMode = false, isPlaceholder: isPlaceholder })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const text = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return isClearMode ? formatMessage((0, $3a77c66a57ad2118$export$defe85febe8b728c).clearPromptHover) : formatMessage((0, $3a77c66a57ad2118$export$defe85febe8b728c).editPromptHover);
    }, [
        isClearMode,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        id: "edit-prompt-hover-button",
        "data-testid": "edit-prompt-hover-button",
        className: (0, $gMc0m.default)([
            "_1o9zidpf _18u01wug _19pk1i6y _otyr1i6y _1e0c116y _tzy4idpf",
            "_1npcidpf _1gicidpf _1e09idpf _1mspidpf _1vf2tlke _1at8v77o _1cjov77o _1yg612x7 _hjaq12x7",
            isPlaceholder && "_1vf273ad"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ho4zm.default), {
            text: text
        })
    });
};


/* LatestPromptRenderer.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 


parcelRequire("42omo");





var $67O0h = parcelRequire("67O0h");


var $lspPP = parcelRequire("lspPP");

const $89b92009584e8b14$var$rendererContainerStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $89b92009584e8b14$var$rendererDocumentStyles = null;
const $89b92009584e8b14$var$RendererWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _l0ms15vq _1aiy15vq _btic1l2s _pkxt1q9c _1wzj1wug _usad1hna _ceky1ufz _hgabu2gc _1vmmkb7n _hgakkb7n _p8i3j915 _1a6vb3bt _1mrdf705 _q3ck1q9c",
            "_c71l1xlq _motn1m6u _1u151tcg"
        ]),
        children: children
    });
};
const $89b92009584e8b14$export$308e8087851b72a3 = ({ promptADF: promptADF, providerFactory: providerFactory })=>{
    const jsonDocument = promptADF;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lspPP.RendererActionsContext), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($89b92009584e8b14$var$RendererWrapper, {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $67O0h.default), {
                document: jsonDocument,
                media: {
                    // We don't currently support images with captions
                    allowLinking: false
                },
                // the nodes and marks the markdown transformer can create.
                // see packages/editor/adf-schema/src/schema/default-schema.ts for details.
                useSpecBasedValidator: true,
                dataProviders: providerFactory,
                maxHeight: 20
            })
        })
    });
};



var $bwdMU = parcelRequire("bwdMU");




const $a6ad6c004f3a0bb1$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    editPrompt: {
        id: "fabric.editor.ai.screens.preview.header.edit",
        defaultMessage: "Edit prompt"
    }
});


const $e9a2eb33803b70e9$var$PROMPT_CONTENT_ID = 'ai-latest-prompt-content'; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $e9a2eb33803b70e9$var$headerEditStylesUnbounded = null;
const $e9a2eb33803b70e9$var$headerEditStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $e9a2eb33803b70e9$var$contentContainerStylesUnbounded = null;
const $e9a2eb33803b70e9$var$contentContainerStyles = null;
const $e9a2eb33803b70e9$var$fullWidth = {
    default: "_1bsb1osq"
};
const $e9a2eb33803b70e9$var$titleContentWrapper = {
    default: "_16jlkb7n _1ul9idpf"
}; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $e9a2eb33803b70e9$var$headerStylesUnbounded = null;
const $e9a2eb33803b70e9$var$headerStyles = null; // header has width/padding at the same time
// if there is very long prompt, header will be wider than parent
// so it should be border-box
const $e9a2eb33803b70e9$var$headerBoxSizingStyles = null;
const $e9a2eb33803b70e9$export$289e4ad0cf050b01 = ({ parentPresetPromptLabel: parentPresetPromptLabel, childShortTitle: childShortTitle, prompt: prompt, promptADF: promptADF, presetTitle: presetTitle, providerFactory: providerFactory, onEditPromptClick: onEditPromptClick, isClearTitle: isClearTitle, agent: agent, showBack: showBack, onBack: onBack, onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)(); // when used in Loading screen, there is no onEditPromptClick
    const canEdit = !!onEditPromptClick;
    const promptContent = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        if (promptADF) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $89b92009584e8b14$export$308e8087851b72a3), {
                    promptADF: promptADF,
                    providerFactory: providerFactory
                }),
                !presetTitle && /*#__PURE__*/ (0, $l998X.jsx)((0, $414d03f659b34c15$export$3a1fe5569d8f8994), {
                    isClearMode: !presetTitle && !prompt,
                    isPlaceholder: !canEdit
                })
            ]
        });
        if (prompt) return /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _ct361wug _slp31hna"
            ]),
            children: prompt
        });
        return null;
    }, [
        canEdit,
        prompt,
        promptADF,
        providerFactory,
        presetTitle
    ]);
    const refinementTagProps = (0, $9LxGu.useAgentRefinementTagProps)(agent);
    const header = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useMemo(()=>{
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            children: [
                showBack && /*#__PURE__*/ (0, $l998X.jsx)((0, $9q1Mo.BackIconButton), {
                    inPromptHeader: true,
                    isDisabled: !canEdit,
                    stopPropagation: true,
                    onClick: onBack
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                    direction: "column",
                    gap: "space.050",
                    xcss: $e9a2eb33803b70e9$var$titleContentWrapper.default,
                    children: [
                        presetTitle && /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                    onClick: (e)=>{
                                        e.stopPropagation();
                                        e.preventDefault();
                                    },
                                    children: isClearTitle ? /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                        weight: 'semibold',
                                        children: presetTitle
                                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $bwdMU.RefinementTag), {
                                        label: presetTitle,
                                        ...refinementTagProps,
                                        onClick: canEdit ? ()=>{
                                            if (onBack) onBack();
                                        } : undefined
                                    })
                                }),
                                presetTitle && /*#__PURE__*/ (0, $l998X.jsx)((0, $414d03f659b34c15$export$3a1fe5569d8f8994), {
                                    isClearMode: !!presetTitle && !prompt,
                                    isPlaceholder: !canEdit
                                })
                            ]
                        }),
                        promptContent
                    ]
                }),
                !!onClose && /*#__PURE__*/ (0, $l998X.jsx)((0, $75921729b8ea3338$export$777abcc87b2abd7a), {
                    onClick: onClose
                })
            ]
        });
    }, [
        showBack,
        canEdit,
        onBack,
        presetTitle,
        isClearTitle,
        refinementTagProps,
        prompt,
        promptContent,
        onClose
    ]);
    if (!(prompt || presetTitle)) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "prompt-header",
        xcss: $e9a2eb33803b70e9$var$fullWidth.default,
        children: !canEdit ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
            id: $e9a2eb33803b70e9$var$PROMPT_CONTENT_ID,
            "data-testid": $e9a2eb33803b70e9$var$PROMPT_CONTENT_ID,
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _ca0qutpp _n3tdutpp _19bvutpp _u5f3utpp _1i4q1hna _1bsb1osq",
                "_gh0qgktf",
                "_vchhusvi",
                "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _ct361wug _slp31hna",
                "_vwz4gktf"
            ]),
            children: header
        }) : /*#__PURE__*/ (0, $l998X.jsx)("button", {
            type: "button",
            "data-testid": "edit-prompt-button",
            onClick: onEditPromptClick,
            "aria-label": formatMessage((0, $a6ad6c004f3a0bb1$export$defe85febe8b728c).editPrompt),
            "aria-describedby": $e9a2eb33803b70e9$var$PROMPT_CONTENT_ID,
            className: (0, $gMc0m.default)([
                "_1reo15vq _18m915vq _ca0qutpp _n3tdutpp _19bvutpp _u5f3utpp _1i4q1hna _1bsb1osq",
                "_gh0qgktf",
                "_vchhusvi",
                "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _ct361wug _slp31hna",
                "_vwz4gktf",
                "_19itglyw _2rko1mok _80omtlke _1bsb1osq _bfhk1j28 _y3gnv2br",
                "_syaz1kw7 _1wybn7od _vwz41kw7 _mrkbidpf _1o0zidpf _gemckb7n _y2mvdfik _1bg41i6y _irr31dpa _1di6fcek"
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                id: $e9a2eb33803b70e9$var$PROMPT_CONTENT_ID,
                "data-testid": $e9a2eb33803b70e9$var$PROMPT_CONTENT_ID,
                children: header
            })
        })
    });
};
module.exports["LatestPromptHeader"] = $e9a2eb33803b70e9$export$289e4ad0cf050b01;

});

parcelRegister("9LxGu", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $hezkK = parcelRequire("hezkK");

function $ba8341fac4d94d12$export$e8e2b5fd4b3854f2(agent) {
    const props = (0, $42omo.useMemo)(()=>{
        if (agent) return {
            elemBefore: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                "data-testId": "command-palette-rovo-agent-icon",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hezkK.AgentAvatar), {
                    agentId: agent.id,
                    agentNamedId: agent.externalConfigReference ?? agent.namedId,
                    agentIdentityAccountId: agent.identityAccountId,
                    isForgeAgent: agent.creatorType === 'FORGE',
                    forgeAgentIconUrl: agent.icon,
                    label: agent.name,
                    size: "xsmall"
                })
            }),
            appearance: 'rounded'
        };
        else return undefined;
    }, [
        agent
    ]);
    return props;
}
module.exports["useAgentRefinementTagProps"] = $ba8341fac4d94d12$export$e8e2b5fd4b3854f2;

});

parcelRegister("bwdMU", function(module, exports) {
/* RefinementTag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");


var $3WVxj = parcelRequire("3WVxj");

var $ho4zm = parcelRequire("ho4zm");


var $cgtv4 = parcelRequire("cgtv4");

var $36b144a94efd45fa$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    removeLabel: {
        id: "fabric.editor.ai.screens.promptWithSelectedOption.removeLabel",
        defaultMessage: "Remove"
    },
    promptSelected: {
        id: "fabric.editor.ai.screens.promptWithSelectedOption.promptSelected",
        defaultMessage: "{promptName} - Selected"
    }
});


const $4d07a272adce5f25$var$cssVars = {
    alignItems: '--align-items',
    elemBeforeHeight: '--elem-before-height'
}; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $4d07a272adce5f25$var$refinementTagStylesVisualRefresh = null; /**
                                                * RefinementTag is the component which renders the
                                                * title of preset prompts such as
                                                * - Brainstorm
                                                * - Summarize
                                                *
                                                * When rendered as part of a user input field, it should provide an
                                                * onClick to display the remove button to allow users to remove the tag.
                                                * When rendered as a presentational element to show which
                                                * preset prompt has been used, it should not provide an onClick
                                                * to keep the tag presentational.
                                                */ 
const $4d07a272adce5f25$export$21c661408d518ab6 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ label: label, onClick: onClick, elemBefore: elemBefore, appearance: appearance }, ref)=>{
    const styles = {
        [$4d07a272adce5f25$var$cssVars.alignItems]: appearance === 'rounded' ? 'center' : 'flex-start',
        [$4d07a272adce5f25$var$cssVars.elemBeforeHeight]: appearance === 'rounded' ? '100%' : 'auto'
    };
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: styles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf _18vq4x5u _1k2cidpf _b3iiidpf _spsw16ko _qxh5o3gi",
            "refinement-tag"
        ]),
        "data-testid": "command-palette-refinement-tag",
        role: "status",
        "aria-atomic": "true",
        "aria-label": formatMessage((0, $36b144a94efd45fa$export$2e2bcd8739ae039).promptSelected, {
            promptName: label
        }),
        "aria-live": "assertive",
        ref: ref,
        children: !onClick ? /*#__PURE__*/ (0, $l998X.jsx)((0, $ho4zm.default), {
            testId: 'refinement-tag',
            text: label,
            elemBefore: elemBefore,
            appearance: appearance
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $3WVxj.default), {
            appearance: appearance,
            elemBefore: elemBefore,
            testId: 'refinement-tag',
            removeButtonLabel: formatMessage((0, $36b144a94efd45fa$export$2e2bcd8739ae039).removeLabel),
            text: label,
            onBeforeRemoveAction: ()=>{
                onClick();
                return false;
            }
        })
    });
});
module.exports["RefinementTag"] = $4d07a272adce5f25$export$21c661408d518ab6;

});

parcelRegister("f02sP", function(module, exports) {
/* UnhandledError.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $8C5kA = parcelRequire("8C5kA");


var $aFUXX = parcelRequire("aFUXX");


var $dh538 = parcelRequire("dh538");


var $6F6hl = parcelRequire("6F6hl");


var $imfiV = parcelRequire("imfiV");


var $BPkYg = parcelRequire("BPkYg");


var $4pXOZ = parcelRequire("4pXOZ");

// Where do we get this magic number 500?
// - The lowest product z-index we need to be below is 500 from the Feedback Collector.
// As well as the Editor toolbar popup menu, which is also 500.
// This allows us to be above the floating toolbar, but below the feedback collector.
// +2 because tables floating toolbar is +1.
const $d6a38d051faab504$var$MAX_Z_INDEX = 500; // Where do we get this magic number 402?
// - The highest product z-index we need to be above is 401 from the floating toolbar*.
// *in Confluence and Bitbucket. It is 600px in Atlas & 511 in Jira, however that is a more niche case than the Feedback Collector,
// so this is a known trade-off until we have a better solution.
const $d6a38d051faab504$var$MIN_Z_INDEX = 402; // Sets the z-index so it is not greater than the maximum, and less than the minimum.
const $d6a38d051faab504$var$akAiModalRegionZIndex = Math.min($d6a38d051faab504$var$MAX_Z_INDEX, Math.max($d6a38d051faab504$var$MIN_Z_INDEX, (0, $aFUXX.akEditorFloatingPanelZIndex) + 2));
const $d6a38d051faab504$var$errorScreenCSS = null;
const $d6a38d051faab504$var$errorScreenCSSUnbounded = null;
const $d6a38d051faab504$export$40729e8ab35829ea = ({ onCancel: onCancel, text: text, inContentComponent: inContentComponent })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [setBreakpointsElement, { breakpoint: breakpoint }] = (0, $imfiV.useElementBreakpoints)();
    const [width, setWidth] = (0, $42omo.useState)(undefined); // when this is rendered in the content component, we have to calc it's width
    const onDivRef = (0, $42omo.useCallback)((node)=>{
        if (inContentComponent && !width && node && node.parentNode instanceof HTMLElement && (0, $dh538.fg)('aifc_create_enabled')) setWidth(node.parentNode.clientWidth);
    }, [
        inContentComponent,
        width
    ]);
    const cnt = /*#__PURE__*/ (0, $l998X.jsxs)((0, $BPkYg.ErrorFloatingContainer), {
        ref: setBreakpointsElement,
        breakpoint: breakpoint,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                children: formatMessage((0, $4pXOZ.default).ariaErrorTitle)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $BPkYg.ErrorMessage), {
                breakpoint: breakpoint,
                children: text
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $BPkYg.ErrorButtonContainer), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $BPkYg.ErrorButton), {
                    autoFocus: true,
                    testId: 'cancel',
                    onClick: onCancel,
                    appearance: "primary",
                    children: formatMessage((0, $dh538.fg)('aifc_create_enabled') ? (0, $4pXOZ.default).closeLabel : (0, $4pXOZ.default).cancelLabel)
                })
            })
        ]
    }); // when this is rendered in the content component, we have to add a wrapper div to apply some styles like position and zIndex
    // for z-index
    // - this will ensure it's applied properly because passing is via css to ErrorFloatingContainer won't work
    // - the z-index will be compiled to a css custom property, but the css custom property is undefined
    // - normally, the css custom property will be defined on the same dom element
    return inContentComponent && (0, $dh538.fg)('aifc_create_enabled') ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: onDivRef,
        className: (0, $gMc0m.default)([
            "_kqswstnw",
            "_1pby1kbs"
        ]),
        style: {
            width: width,
            "--_1dsp0pi": (0, $7sObp.default)($d6a38d051faab504$var$akAiModalRegionZIndex)
        },
        children: cnt
    }) : cnt;
};
module.exports["UnhandledErrorScreen"] = $d6a38d051faab504$export$40729e8ab35829ea;

});

parcelRegister("BPkYg", function(module, exports) {
/* error-screen-parts.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");


var $5MACL = parcelRequire("5MACL");


var $a3fRD = parcelRequire("a3fRD");


var $dh538 = parcelRequire("dh538");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $kuYGt = parcelRequire("kuYGt");


var $40sdH = parcelRequire("40sdH");


var $imfiV = parcelRequire("imfiV");


var $4pXOZ = parcelRequire("4pXOZ");

const $c4df1a880a13e405$var$buttonContainerStyles = null;
const $c4df1a880a13e405$var$cmdPaletteButtonContainerStyles = {
    container: "_zulp1b66 _1e0c1txw _1n261g80 _2lx2vrvc _1bahesu3 _4cvr1h6o _zs121b66 _jq8gxy5q _xlob1h6o",
    primaryButton: "_stfgia51"
}; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $c4df1a880a13e405$var$divWrapperContainerStyleUnbounded = null;
const $c4df1a880a13e405$var$divWrapperContainerStyle = null;
const $c4df1a880a13e405$var$smallBreakPointAlignItems = null;
const $c4df1a880a13e405$var$errorFloatingContainerStyle = null;
const $c4df1a880a13e405$var$smallErrorFloatingContainerStyle = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $c4df1a880a13e405$var$spanWrapperStyleUnbounded = null;
const $c4df1a880a13e405$var$spanWrapperStyle = null;
const $c4df1a880a13e405$var$smallBreakPointTop = null;
const $c4df1a880a13e405$var$dangerIconPaddingStyle = null;
function $c4df1a880a13e405$export$915e9e7bd4f0f96d({ children: children, breakpoint: breakpoint }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx2vrvc _1bah1y6m _4cvr1h6o",
            "_zulp19bv",
            breakpoint <= (0, $imfiV.Breakpoint).Small && "_4cvr1y6m"
        ]),
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    "_1e0c116y _4cvr1h6o _1bah1h6o _kqswh2mm _1o9zidpf _154ize3t",
                    "_vwz4kb7n",
                    breakpoint <= (0, $imfiV.Breakpoint).Small && "_154i1i6y"
                ]),
                children: (0, $dh538.fg)('aifc_create_enabled') ? /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    className: (0, $gMc0m.default)([
                        "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                        label: formatMessage((0, $4pXOZ.default).warningIconLabel),
                        color: "var(--ds-icon-danger, #C9372C)"
                    })
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5MACL))), {
                    label: formatMessage((0, $4pXOZ.default).warningIconLabel),
                    color: "var(--ds-icon-warning, #E06C00)"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                as: "p",
                children: children
            })
        ]
    });
}
function $c4df1a880a13e405$export$a359b30953f5499e({ children: children, onClick: onClick, appearance: appearance, testId: testId, autoFocus: autoFocus, disabled: disabled = false }) {
    const shouldUseSubtleStyle = (0, $dh538.fg)('aifc_create_enabled') && appearance === 'primary';
    const finalAppearance = shouldUseSubtleStyle ? 'subtle' : appearance;
    const button = /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
        autoFocus: autoFocus,
        testId: testId,
        spacing: "compact",
        onClick: onClick,
        type: "button",
        appearance: finalAppearance,
        isDisabled: disabled,
        children: children
    });
    if (shouldUseSubtleStyle) return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        xcss: $c4df1a880a13e405$var$cmdPaletteButtonContainerStyles.primaryButton,
        children: button
    });
    return button;
}
function $c4df1a880a13e405$export$e7ce0c27e387222f({ children: children }) {
    return (0, $dh538.fg)('aifc_create_enabled') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        xcss: $c4df1a880a13e405$var$cmdPaletteButtonContainerStyles.container,
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw _1n261g80 _2lx2vrvc _1bahesu3 _4cvr1h6o"
        ]),
        children: children
    });
} // Need to use forwardRef because functional component cannot be passed a ref
const $c4df1a880a13e405$export$f31c7963ee61af = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, breakpoint: breakpoint, appearance: appearance }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $40sdH.FloatingContainer), {
        ref: ref,
        "data-testid": "error-screen" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        ,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw _2lx2vrvc",
            breakpoint <= (0, $imfiV.Breakpoint).Small && "_zulppxbi _1e0c1txw _2lx21bp4",
            `error-screen ${(0, $kuYGt.AI_MODAL_SCREEN_CLASS)}`
        ]),
        paddingAdjustments: (0, $dh538.fg)('aifc_create_enabled') ? {
            right: 4,
            left: 4
        } : {
            top: 1,
            bottom: 1
        },
        rainbowBorder: false,
        appearance: appearance,
        children: children
    });
});
module.exports["ErrorMessage"] = $c4df1a880a13e405$export$915e9e7bd4f0f96d;
module.exports["ErrorButton"] = $c4df1a880a13e405$export$a359b30953f5499e;
module.exports["ErrorButtonContainer"] = $c4df1a880a13e405$export$e7ce0c27e387222f;
module.exports["ErrorFloatingContainer"] = $c4df1a880a13e405$export$f31c7963ee61af;

});

parcelRegister("4pXOZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $6e460e0007319cff$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $6e460e0007319cff$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    documentInsertError: {
        id: "fabric.editor.ai.experience-application.documentInsertError",
        defaultMessage: "We're having trouble inserting the response. Close the dialog and try again."
    },
    tokenLimitExceeded: {
        id: "fabric.editor.ai.experience-application.tokenLimitExceeded",
        defaultMessage: "We couldn't get a response. Your prompt or response was over the limit for this request. Close the dialog and try again."
    },
    apiError: {
        id: "fabric.editor.ai.experience.apiError",
        defaultMessage: "We couldn\u2019t get a response, please try again."
    },
    inputTooShortError: {
        id: "fabric.editor.ai.experience.inputTooShortError",
        defaultMessage: "The content is too short to summarize. Please add more and try again."
    },
    cancelLabel: {
        id: "fabric.editor.ai.screens.error.cancelLabel",
        defaultMessage: "Cancel"
    },
    closeLabel: {
        id: "fabric.editor.ai.screens.error.closeLabel",
        defaultMessage: "Close"
    },
    retryLabel: {
        id: "fabric.editor.ai.screens.error.retryLabel",
        defaultMessage: "Try again"
    },
    warningIconLabel: {
        id: "fabric.editor.ai.screens.error.warningIconLabel",
        defaultMessage: "Warning"
    },
    ariaErrorTitle: {
        id: "fabric.editor.ai.screens.error.ariaErrorTitle",
        defaultMessage: "Error"
    }
});

});

parcelRegister("9zowQ", function(module, exports) {
/* FeedbackForm.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxfrag */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $9zIwY = parcelRequire("9zIwY");


var $9FnLD = parcelRequire("9FnLD");


var $gdv5Z = parcelRequire("gdv5Z");


var $6F6hl = parcelRequire("6F6hl");


var $cgtv4 = parcelRequire("cgtv4");

var $723d60dd8af8a494$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    goodResponse: {
        id: "fabric.editor.ai.components.feedbackForm.goodResponse",
        defaultMessage: "Good response"
    },
    badResponse: {
        id: "fabric.editor.ai.components.feedbackForm.badResponse",
        defaultMessage: "Bad response"
    },
    feedbackSent: {
        id: "fabric.editor.ai.components.feedbackForm.feedbackSent",
        defaultMessage: "Feedback sent"
    }
});


const $475e1faaefe5731f$var$hideBackgroundStyles = null;
const $475e1faaefe5731f$var$Announcer = ({ message: message, shouldAnnounce: shouldAnnounce })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            "aria-atomic": "true",
            "aria-live": "polite",
            children: shouldAnnounce && message
        })
    });
};
const $475e1faaefe5731f$var$FeedbackButton = ({ type: type, onClick: onClick, isPressed: isPressed, isDisabled: isDisabled })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const responseLabel = type === 'good' ? formatMessage((0, $723d60dd8af8a494$export$2e2bcd8739ae039).goodResponse) : formatMessage((0, $723d60dd8af8a494$export$2e2bcd8739ae039).badResponse);
    const color = isPressed ? "var(--ds-link-pressed, #1558BC)" : 'currentColor';
    const Icon = ()=>type === 'good' ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FnLD))), {
            label: responseLabel,
            color: color
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9zIwY))), {
            label: responseLabel,
            color: color
        });
    const tooltipOptions = {
        position: 'top',
        content: responseLabel
    };
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            (isPressed || isDisabled) && "_7dirsm61"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
            testId: `${type}-response-feedback-button`,
            type: "button",
            isDisabled: isDisabled,
            onClick: onClick,
            icon: Icon,
            label: responseLabel,
            appearance: "subtle",
            spacing: "compact",
            isTooltipDisabled: false,
            tooltip: tooltipOptions
        })
    });
};
const $475e1faaefe5731f$export$ce859c56062f484c = ({ onGoodResponseButtonClick: onGoodResponseButtonClick, onBadResponseButtonClick: onBadResponseButtonClick, isPressed: isPressed, isDisabled: isDisabled })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const feedbackWasSentLabel = formatMessage((0, $723d60dd8af8a494$export$2e2bcd8739ae039).feedbackSent);
    const [feedbackSelected, setFeedbackSelected] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState();
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((onClick, feedback)=>()=>{
            onClick();
            setFeedbackSelected(feedback);
        }, [
        setFeedbackSelected
    ]);
    const disableButton = !!isPressed || isDisabled || !!feedbackSelected;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($475e1faaefe5731f$var$Announcer, {
                message: feedbackWasSentLabel,
                shouldAnnounce: Boolean(feedbackSelected)
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($475e1faaefe5731f$var$FeedbackButton, {
                type: "good",
                isPressed: isPressed === 'good',
                isDisabled: disableButton,
                onClick: handleOnClick(onGoodResponseButtonClick, 'good')
            }),
            /*#__PURE__*/ (0, $l998X.jsx)($475e1faaefe5731f$var$FeedbackButton, {
                type: "bad",
                isPressed: isPressed === 'bad',
                isDisabled: disableButton,
                onClick: handleOnClick(onBadResponseButtonClick, 'bad')
            })
        ]
    });
};
module.exports["FeedbackForm"] = $475e1faaefe5731f$export$ce859c56062f484c;

});

parcelRegister("3gD8G", function(module, exports) {

var $cMZNY = parcelRequire("cMZNY");


var $5SAOw = parcelRequire("5SAOw");

const $419edf111d0cfe8d$var$toDOM = (fragment, schema)=>{
    return (0, $5SAOw.DOMSerializer).fromSchema(schema).serializeFragment(fragment);
};
/**
 * Copied and amended from platform/packages/editor/editor-plugin-paste/src/pm-plugins/clipboard-text-serializer.ts
 */ function $419edf111d0cfe8d$var$clipboardTextSerializer(fragment) {
    let text = '';
    const blockSeparater = '\n\n';
    fragment.nodesBetween(0, fragment.size, (node)=>{
        if (node.type.isBlock) text += blockSeparater;
        if (node.type.name === 'paragraph') return true;
        else if (node.type.name === 'hardBreak') text += '\n';
        else if (node.type.name === 'text') text += node.text;
        else if (node.type.name === 'inlineCard') text += node.attrs.url;
        else if (node.type.name === 'blockCard') text += node.attrs.url;
        else text += node.textBetween(0, node.content.size, '\n\n');
        return false;
    });
    return text.trim();
}
function $419edf111d0cfe8d$export$a707cf6ca97554ae({ editorView: editorView, pmFragment: pmFragment }) {
    const transaction = editorView.state.tr;
    const domNode = $419edf111d0cfe8d$var$toDOM(pmFragment, editorView.state.schema);
    if (domNode) {
        const div = document.createElement('div');
        div.appendChild(domNode);
        // The "0 0" refers to the start and end depth of the slice
        // since we're copying the block node only, it will always be 0 0
        // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        div.firstChild.setAttribute('data-pm-slice', '0 0 []');
        /**
		 * ED-18062: override the plain text in
		 * copyHTMLToClipboard using clipboardTextSerializer(pmFragment)
		 * because HTML to plain text is formatted without new lines
		 * in certain nodes such as lists
		 */ (0, $cMZNY.copyHTMLToClipboard)(div, $419edf111d0cfe8d$var$clipboardTextSerializer(pmFragment));
    }
    transaction.setMeta('scrollIntoView', false);
    editorView.dispatch(transaction);
}
module.exports["copyPMFragmentToClipboard"] = $419edf111d0cfe8d$export$a707cf6ca97554ae;

});

parcelRegister("6dSQX", function(module, exports) {
/* Preview.tsx generated by @compiled/babel-plugin v0.36.1 */ // Entry file
/* eslint-disable @atlaskit/editor/no-re-export */ /** @jsxFrag */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $kB2tR = parcelRequire("kB2tR");


var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $82gXq = parcelRequire("82gXq");


var $3gadb = parcelRequire("3gadb");


var $6F6hl = parcelRequire("6F6hl");


var $kuYGt = parcelRequire("kuYGt");

/* ButtonWithShortcut.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $fFa3V = parcelRequire("fFa3V");


var $eEA8O = parcelRequire("eEA8O");


var $d7ZU3 = parcelRequire("d7ZU3");


var $1oCLl = parcelRequire("1oCLl");

/* Shortcut.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $hgeg8 = parcelRequire("hgeg8");

const $fb6ab6e57de2ff7c$var$styleUnbounded = null;
const $fb6ab6e57de2ff7c$var$style = null;
function $fb6ab6e57de2ff7c$export$59451aa6b6270879({ shortcut: shortcut }) {
    const formattedShortcut = (0, $hgeg8.formatShortcut)(shortcut);
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            "_2rko12b0 _syazazsu _bfhki8nm _k48pi7a9",
            "_ca0q1l7b _u5f31l7b _n3td1l7b _19bv1l7b _18u0i2wt"
        ]),
        children: formattedShortcut
    });
}


/**
 * Checks if a keyboard event matches a given shortcut.
 *
 * @param event - The keyboard event to check.
 * @param shortcut - The shortcut string to match against (e.g., "Ctrl-Shift-A").
 * @returns True if the event matches the shortcut, false otherwise.
 */ function $2ade9a5d68269bab$export$b6ac0c7de16a0eb8(event, shortcut) {
    const parts = shortcut.split('-');
    const key = parts.pop();
    const mods = new Set(parts);
    if (event.key !== key) return false;
    if (mods.has('Mod') !== event.metaKey) return false;
    if (mods.has('Shift') !== event.shiftKey) return false;
    if (mods.has('Alt') !== event.altKey) return false;
    if (mods.has('Ctrl') !== event.ctrlKey) return false;
    return true;
}


const $ab92869aa5ca99ad$var$buttonAutoFocusRingFix = null;
const $ab92869aa5ca99ad$var$forceFocusRingStyles = null;
function $ab92869aa5ca99ad$export$3ca6788437e93171({ shortcut: shortcut, children: children, forceFocusRing: forceFocusRing, buttonAutoFocusRing: buttonAutoFocusRing, onClick: onClick, ...rest }) {
    (0, $42omo.useEffect)(()=>{
        const listener = (event)=>{
            if (shortcut?.common && (0, $2ade9a5d68269bab$export$b6ac0c7de16a0eb8)(event, shortcut.common)) {
                event.preventDefault();
                event.stopPropagation();
                onClick?.();
            }
        };
        return (0, $fFa3V.bind)(document, {
            type: 'keydown',
            listener: listener
        });
    }, [
        onClick,
        shortcut
    ]);
    const content = (0, $42omo.useMemo)(()=>{
        if (!shortcut) return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
            children: children
        });
        const browser = (0, $1oCLl.expValEquals)('platform_editor_hydratable_ui', 'isEnabled', true) ? (0, $d7ZU3.getBrowserInfo)() : (0, $d7ZU3.browser);
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    "aria-keyshortcuts": browser.mac ? shortcut?.mac : shortcut?.windows,
                    children: children
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb6ab6e57de2ff7c$export$59451aa6b6270879), {
                        shortcut: shortcut
                    })
                })
            ]
        });
    }, [
        shortcut,
        children
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
    ), {
        onClick: onClick,
        ...rest,
        className: (0, $gMc0m.default)([
            forceFocusRing && "_7br8dfik _5wkdv77o",
            buttonAutoFocusRing && "_15y8dfik _2en4v77o"
        ]),
        children: content
    });
}


/* CopyIconButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $1qfLF = parcelRequire("1qfLF");


var $2MuFw = parcelRequire("2MuFw");


var $cgtv4 = parcelRequire("cgtv4");

var $6d869f2d458e30a9$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    copy: {
        id: "fabric.editor.ai.config.item.action.copyResponse",
        defaultMessage: "Copy"
    },
    copied: {
        id: "fabric.editor.ai.config.item.action.responseCopied",
        defaultMessage: "Copied!"
    },
    copiedToClipboard: {
        id: "fabric.editor.ai.config.item.action.responseCopiedToClipboard",
        defaultMessage: "Copied to clipboard"
    }
});


const $f0460d394892f7ed$export$dcd7ef7785e10577 = ({ onClick: onClick, tabIndex: tabIndex, appearance: appearance, spacing: spacing })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [tooltip, setTooltip] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(formatMessage((0, $6d869f2d458e30a9$export$2e2bcd8739ae039).copy));
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef();
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((event)=>{
        onClick(event);
        setTooltip(formatMessage((0, $6d869f2d458e30a9$export$2e2bcd8739ae039).copiedToClipboard));
    }, [
        onClick,
        formatMessage
    ]);
    const resetTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>setTooltip(formatMessage((0, $6d869f2d458e30a9$export$2e2bcd8739ae039).copy)), [
        formatMessage
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useLayoutEffect(()=>{
        updateTooltip.current?.();
    }, [
        tooltip
    ]);
    const tooltipOptions = {
        position: 'top',
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return tooltip;
        },
        onHide: resetTooltip
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        testId: "copy-response-button",
        type: "button",
        onClick: handleOnClick,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2MuFw))),
        label: tooltip,
        appearance: appearance,
        spacing: spacing,
        tabIndex: tabIndex,
        isTooltipDisabled: false,
        tooltip: tooltipOptions
    });
};



var $9zowQ = parcelRequire("9zowQ");


var $40sdH = parcelRequire("40sdH");


var $jHWjW = parcelRequire("jHWjW");


var $8PgnR = parcelRequire("8PgnR");


var $2NU90 = parcelRequire("2NU90");

/* RetryIconButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");








var $d8ohW = parcelRequire("d8ohW");




var $77fa638be64783b6$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    retryPrompt: {
        id: "fabric.editor.ai.config.item.action.retryPrompt",
        defaultMessage: "Retry"
    }
});


const $054114d4e1c712d8$export$6f66175e87cc7542 = ({ onClick: onClick, tabIndex: tabIndex, appearance: appearance, spacing: spacing, isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const tooltip = formatMessage((0, $77fa638be64783b6$export$2e2bcd8739ae039).retryPrompt);
    const tooltipOptions = {
        position: 'top',
        hideTooltipOnClick: true,
        content: tooltip
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        testId: "retry-prompt-button",
        type: "button",
        onClick: onClick,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d8ohW))),
        label: tooltip,
        appearance: appearance,
        spacing: spacing,
        tabIndex: tabIndex,
        isTooltipDisabled: false,
        tooltip: tooltipOptions,
        isDisabled: isDisabled
    });
};


/* ActionButtonsLayout.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 


parcelRequire("42omo");










function $63e451a97e81592b$export$1ca3f17e50a1bf69() {
    const [element, setElement] = (0, $42omo.useState)(null);
    const [result, setResult] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!element) return;
        const updateResult = (entries)=>{
            for (const entry of entries){
                const firstChild = entry.target.firstElementChild;
                if (!(firstChild instanceof HTMLElement)) {
                    setResult(false);
                    return;
                }
                const firstChildTop = firstChild.offsetTop;
                // Check that all elements in the same row, if not, set result to true.
                // We can't check the first and last element because the may have different visual position,
                // because of order CCS property.
                const isInTwoLine = Array.from(entry.target.children).some((child)=>child instanceof HTMLElement && child.offsetTop !== firstChildTop);
                setResult(isInTwoLine);
            }
        };
        const resizeObserver = new ResizeObserver(updateResult);
        resizeObserver.observe(element);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        element
    ]);
    return [
        setElement,
        result
    ];
}





var $63aac829604a098b$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    logoAltText: {
        id: "fabric.editor.ai.screens.prompt.logoAltText",
        defaultMessage: "Atlassian Intelligence Logo"
    },
    logoText: {
        id: "fabric.editor.ai.screens.prompt.logoText",
        defaultMessage: "Atlassian Intelligence"
    },
    betaLabel: {
        id: "fabric.editor.ai.screens.preview.betaLabel",
        defaultMessage: "Beta"
    },
    cancelLabel: {
        id: "fabric.editor.ai.screens.preview.cancelLabel",
        defaultMessage: "Cancel"
    },
    discardLabel: {
        id: "fabric.editor.ai.screens.preview.discardLabel",
        defaultMessage: "Discard"
    },
    defaultInputPlaceholder: {
        id: "fabric.editor.ai.screens.preview.defaultAIPlaceholder",
        defaultMessage: "Tell AI what to do next"
    },
    defaultRovoInputPlaceholder: {
        id: "fabric.editor.ai.screens.preview.defaultRovoInputPlaceholder",
        defaultMessage: "Tell Rovo what to do next"
    },
    placeholderWithAgent: {
        id: "fabric.editor.ai.screens.preview.placeholderWithAgent",
        defaultMessage: "Ask {agentName} what to do next"
    },
    disclaimer: {
        id: "fabric.editor.ai.screens.preview.disclaimer",
        defaultMessage: "Information quality may vary."
    },
    disclaimerLink: {
        id: "fabric.editor.ai.screens.preview.disclaimerLink",
        defaultMessage: "Learn why"
    },
    previewScreenLabel: {
        id: "fabric.editor.ai.experience.previewScreenLabel",
        defaultMessage: "Preview"
    },
    refineButton: {
        id: "fabric.editor.ai.screens.preview.refineButton",
        defaultMessage: "Refine"
    },
    highlightDifferencesLabel: {
        id: "fabric.editor.ai.screens.preview.highlightDifferencesLabel.non-final",
        defaultMessage: "Highlight differences"
    },
    highlightDifferencesDisabledTooltip: {
        id: "fabric.editor.ai.screens.preview.highlightDifferencesDisabledTooltip.non-final",
        defaultMessage: "This feature is not available for this AI generated response."
    },
    actionButtonsAccessibleLabel: {
        id: "fabric.editor.ai.screens.preview.actionButtonsAccessibleLabel",
        defaultMessage: "Actions for AI generated content"
    },
    actionButtonsTryAgain: {
        id: "fabric.editor.ai.screens.preview.actionButtonsTryAgain",
        defaultMessage: "Try again"
    },
    actionButtonsAccept: {
        id: "fabric.editor.ai.screens.preview.actionButtonsAccept",
        defaultMessage: "Accept"
    }
});


const $8d7c140c81666045$var$container = null;
const $8d7c140c81666045$var$secondLevelContainer = null;
const $8d7c140c81666045$var$compactSecondaryButtonsContainer = null;
function $8d7c140c81666045$export$6a458a35d6b615d0({ cancelButton: cancelButton, primaryButtons: primaryButtons, secondaryButtons: secondaryButtons }) {
    // The Discard button should be the last when there are two lines of buttons.
    //
    // We can't do it just by CSS (for example, by order prop), because CSS order doesn't
    // affect the tab order.
    // And we can't use tabindex, because tabindex is global and change order of all elements.
    // That's why we need to render the Discard button in different places in the DOM,
    // based on the number of lines. Stupid but works=(
    //
    // Also, we can't determinate the line count based on container width
    // because the amount buttons can be different.
    // That's why we use the useIsFlexElementWrapped hook to determine the line count.
    //
    // See more why CSS order and tabindex don't work: https://tink.uk/flexbox-the-keyboard-navigation-disconnect/
    const [setRootContainerElement, isRootContainerWrapped] = (0, $63e451a97e81592b$export$1ca3f17e50a1bf69)();
    const [setSecondLevelContainerElement, isSecondLevelContainerWrapped] = (0, $63e451a97e81592b$export$1ca3f17e50a1bf69)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        ref: setRootContainerElement,
        role: "group",
        "aria-label": formatMessage((0, $63aac829604a098b$export$2e2bcd8739ae039).actionButtonsAccessibleLabel),
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw _1n261g80 _1bahesu3 _ca0qze3t"
        ]),
        children: [
            !isRootContainerWrapped && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_zulpu2gc _1e0c1txw _4cvr1h6o"
                ]),
                children: secondaryButtons
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                ref: setSecondLevelContainerElement,
                className: (0, $gMc0m.default)([
                    "_zulpu2gc _1e0c1txw _1n261g80 _1bahesu3 _ca0qze3t",
                    "_18u01wug"
                ]),
                children: [
                    !isSecondLevelContainerWrapped && cancelButton,
                    primaryButtons && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            "_zulpu2gc _1e0c1txw _1n261g80 _1bahesu3 _ca0qze3t"
                        ]),
                        children: primaryButtons
                    }),
                    isSecondLevelContainerWrapped && cancelButton
                ]
            }),
            isRootContainerWrapped && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_zulpu2gc _1e0c1txw _4cvr1h6o"
                ]),
                children: secondaryButtons
            })
        ]
    });
}


/* RefineDropdown.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 









var $52EPl = parcelRequire("52EPl");




var $5cb356ffb6967308$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    refineButton: {
        id: "fabric.editor.ai.screens.preview.refineDropdown.refineButton",
        defaultMessage: "Refine"
    }
});


/* RefineDropdownItems.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @jsxFrag */ 


parcelRequire("42omo");







var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $15HFc = parcelRequire("15HFc");

function $a206644f87d5b962$export$99f30ba596e90ddb({ items: items, onItemClick: onItemClick, currentOpenedSubMenu: currentOpenedSubMenu, onSubMenuOpenChanged: onSubMenuOpenChanged }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ahaN7.default), {
        children: items.map((item)=>/*#__PURE__*/ (0, $l998X.jsx)($a206644f87d5b962$var$Item, {
                item: item,
                onItemClick: onItemClick,
                currentOpenedSubMenu: currentOpenedSubMenu,
                onSubMenuOpenChanged: onSubMenuOpenChanged
            }, item.title.id))
    });
}
function $a206644f87d5b962$var$Item({ item: item, onItemClick: onItemClick, currentOpenedSubMenu: currentOpenedSubMenu, onSubMenuOpenChanged: onSubMenuOpenChanged }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if ('children' in item && item.children) {
        const handleOpenChange = ({ isOpen: isOpen })=>{
            onSubMenuOpenChanged?.(item, isOpen);
        };
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
            placement: "right-start",
            shouldRenderToParent: true,
            isOpen: currentOpenedSubMenu === item,
            onOpenChange: handleOpenChange,
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default // Ignored via go/ees005
                ), {
                    ...triggerProps,
                    ref: triggerRef,
                    elemBefore: item.icon,
                    elemAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($15HFc))), {
                        color: "var(--ds-icon-subtle, #505258)",
                        label: "",
                        size: "small"
                    }),
                    children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                        children: formatMessage(item.title)
                    })
                }),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ahaN7.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)($a206644f87d5b962$export$99f30ba596e90ddb, {
                    items: item.children,
                    onItemClick: onItemClick
                })
            })
        });
    }
    const handleItemClick = ()=>{
        onItemClick();
        item.onClick?.();
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
        elemBefore: item.icon,
        onClick: handleItemClick,
        children: formatMessage(item.title)
    });
}


function $8b8a21813f13369d$export$892617147bbb1d94({ items: items, onClick: onClick }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isOpened, setIsOpened] = (0, $42omo.useState)(false);
    const [currentOpenedSubMenu, setCurrentOpenedSubMenu] = (0, $42omo.useState)(null);
    const handleOpenChange = (0, $42omo.useCallback)(({ isOpen: isOpen })=>{
        isOpen && onClick && onClick();
        setIsOpened(isOpen);
        if (!isOpen) setCurrentOpenedSubMenu(null);
    }, [
        onClick
    ]);
    const handleItemClick = (0, $42omo.useCallback)(()=>{
        setIsOpened(false);
        setCurrentOpenedSubMenu(null);
    }, []);
    const handleSubMenuOpenChanged = (0, $42omo.useCallback)((subMenu, isOpen)=>{
        setCurrentOpenedSubMenu((current)=>{
            // Close the current opened sub menu if it's not the same as the one that was clicked
            if (current === subMenu && !isOpen) return null;
            return subMenu;
        });
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
        trigger: formatMessage((0, $5cb356ffb6967308$export$2e2bcd8739ae039).refineButton),
        testId: "refine-dropdown",
        shouldRenderToParent: true,
        isOpen: isOpened,
        onOpenChange: handleOpenChange,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a206644f87d5b962$export$99f30ba596e90ddb), {
            items: items,
            onItemClick: handleItemClick,
            currentOpenedSubMenu: currentOpenedSubMenu,
            onSubMenuOpenChanged: handleSubMenuOpenChanged
        })
    });
}



const $6037e01702f2a193$var$hasDiffPreviewStyles = {
    default: "_syaz1gmx _80om13gf"
};
const $6037e01702f2a193$var$previewContainerPaddingStyles = null;
const $6037e01702f2a193$var$columnLayout = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $6037e01702f2a193$var$interrogationWrapper = null;
const $6037e01702f2a193$var$defaultPaddingStyles = null;
const $6037e01702f2a193$var$previewContainerPaddingCompact = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $6037e01702f2a193$var$previewContainerBorders = null;
const $6037e01702f2a193$var$previewFloatingContainerStyle = null;
const $6037e01702f2a193$var$mapActionAppearanceToButtonAppearance = {
    primary: 'primary',
    secondary: 'default',
    cancel: 'subtle'
};
const $6037e01702f2a193$export$9f3706359963c421 = ({ parentPresetPromptLabel: parentPresetPromptLabel, childShortTitle: childShortTitle, staticPromptTitle: staticPromptTitle, staticInsertedPrompt: staticInsertedPrompt, latestPrompt: latestPrompt, preview: preview, diffPreview: diffPreview, canShowVisualDiffPreview: canShowVisualDiffPreview, disableActions: disableActions = false, disableInterrogation: disableInterrogation = false, onSubmit: onSubmit, onCancel: onCancel, onCopy: onCopy, onRetry: onRetry, onInputFocus: onInputFocus, onInputChange: onInputChange, onADFChange: onADFChange, onGoodResponseButtonClick: onGoodResponseButtonClick, onBadResponseButtonClick: onBadResponseButtonClick, onEditPromptClick: onEditPromptClick, onBack: onBack, onShowDiffPreview: onShowDiffPreview, onClose: onClose, showBack: showBack = true, applications: applications, isInputActive: isInputActive, inputValue: inputValue, inputADFValue: inputADFValue, PromptEditor: PromptEditor, clearInputRef: clearInputRef, providerFactory: providerFactory, schema: schema, disclaimer: disclaimer, agent: agent, onRefinementClick: onRefinementClick, refineDropdownItems: refineDropdownItems, hideHorizontalRule: hideHorizontalRule = false, showBetaLozenge: showBetaLozenge = false, isClearTitle: isClearTitle = false, canInlineStreamChanges: canInlineStreamChanges })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [forceFocusRing, setForceFocusRing] = (0, $42omo.useState)(true);
    const presetTitleString = staticPromptTitle ?? latestPrompt?.presetTitle;
    const promptString = staticInsertedPrompt ?? latestPrompt?.userInput;
    const firePrimaryApplication = ()=>{
        if (!applications) return;
        setForceFocusRing(false);
        applications[applications.length - 1].onClick();
    };
    const onInterrogateBlur = (0, $42omo.useCallback)(()=>{
        setForceFocusRing(false);
    }, []);
    const handleOnInputFocus = (0, $42omo.useCallback)(()=>{
        setForceFocusRing(true);
        if (onInputFocus) onInputFocus();
    }, [
        onInputFocus
    ]);
    const focusInputRef = (0, $42omo.useRef)(undefined);
    const initialPlaceholder = agent ? formatMessage((0, $63aac829604a098b$export$2e2bcd8739ae039).placeholderWithAgent, {
        agentName: agent.name
    }) : formatMessage((0, $63aac829604a098b$export$2e2bcd8739ae039).defaultRovoInputPlaceholder);
    const [isDiffPreviewVisible, setIsDiffPreviewVisible] = (0, $42omo.useState)(true);
    const hasValidDiffPreview = !!diffPreview;
    const handleToggleDiffPreviewVisibility = (0, $42omo.useCallback)(()=>{
        setIsDiffPreviewVisible((value)=>{
            onShowDiffPreview?.(!value);
            return !value;
        });
    }, [
        setIsDiffPreviewVisible,
        onShowDiffPreview
    ]);
    const isNewPaletteEnabled = (0, $dh538.fg)('aifc_create_enabled');
    const shouldHidePreviewContent = isNewPaletteEnabled && canInlineStreamChanges; // This is used to determine when to disable a number of features to prevent
    // the user from performing actions on previous responses
    const isViewingLatestResponse = !disableActions && !disableInterrogation;
    const feedbackForm = (0, $42omo.useMemo)(()=>{
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $9zowQ.FeedbackForm), {
            onBadResponseButtonClick: onBadResponseButtonClick,
            onGoodResponseButtonClick: onGoodResponseButtonClick
        });
    }, [
        onBadResponseButtonClick,
        onGoodResponseButtonClick
    ]);
    const actionButtons = (0, $42omo.useMemo)(()=>{
        const secondaryButtons = !disableActions && (isNewPaletteEnabled ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                onCopy && /*#__PURE__*/ (0, $l998X.jsx)((0, $f0460d394892f7ed$export$dcd7ef7785e10577), {
                    spacing: "compact",
                    appearance: "subtle",
                    onClick: onCopy
                }),
                feedbackForm,
                onRetry && /*#__PURE__*/ (0, $l998X.jsx)((0, $054114d4e1c712d8$export$6f66175e87cc7542), {
                    spacing: "compact",
                    appearance: "subtle",
                    onClick: onRetry
                })
            ]
        }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                feedbackForm,
                onRetry && /*#__PURE__*/ (0, $l998X.jsx)((0, $054114d4e1c712d8$export$6f66175e87cc7542), {
                    spacing: "compact",
                    appearance: "subtle",
                    onClick: onRetry
                }),
                onCopy && /*#__PURE__*/ (0, $l998X.jsx)((0, $f0460d394892f7ed$export$dcd7ef7785e10577), {
                    spacing: "compact",
                    appearance: "subtle",
                    onClick: onCopy
                })
            ]
        }));
        const cancelButton = onCancel ? /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
            testId: "discard-button",
            onClick: onCancel,
            type: "button",
            appearance: disableActions ? 'primary' : 'subtle',
            autoFocus: disableActions || applications.length === 0,
            children: formatMessage((0, $63aac829604a098b$export$2e2bcd8739ae039).discardLabel)
        }) : undefined;
        let primaryButtons = !disableActions && applications.map(({ onClick: onClick, label: label, appearance: appearance, shortcut: shortcut, isDisabled: isDisabled, tooltip: tooltip }, index)=>{
            const button = /*#__PURE__*/ (0, $l998X.jsx)((0, $ab92869aa5ca99ad$export$3ca6788437e93171), {
                onClick: onClick,
                type: "button",
                shortcut: shortcut,
                autoFocus: appearance === 'primary',
                forceFocusRing: index === applications.length - 1 && forceFocusRing,
                buttonAutoFocusRing: index === applications.length - 1 && !forceFocusRing,
                appearance: $6037e01702f2a193$var$mapActionAppearanceToButtonAppearance[appearance],
                isDisabled: isDisabled,
                children: label
            }, label);
            if (tooltip) return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                content: tooltip,
                position: "top",
                children: button
            }, `${label}-tooltip`);
            return button;
        });
        if (primaryButtons && !agent && refineDropdownItems) primaryButtons.unshift(/*#__PURE__*/ (0, $l998X.jsx)((0, $8b8a21813f13369d$export$892617147bbb1d94), {
            items: refineDropdownItems,
            onClick: onRefinementClick
        }, "refine-dropdown"));
        if (isNewPaletteEnabled) {
            // still brittle, assumes only 1 primary
            const primaryAction = applications.find((action)=>action.appearance === 'primary');
            if (primaryAction) {
                const acceptButton = /*#__PURE__*/ (0, $l998X.jsx)((0, $ab92869aa5ca99ad$export$3ca6788437e93171), {
                    onClick: primaryAction?.onClick,
                    type: "button",
                    shortcut: primaryAction?.shortcut,
                    autoFocus: true,
                    appearance: "primary",
                    isDisabled: primaryAction?.isDisabled,
                    children: formatMessage((0, $63aac829604a098b$export$2e2bcd8739ae039).actionButtonsAccept)
                }, (0, (/*@__PURE__*/$parcel$interopDefault($kB2tR)))(primaryAction?.label));
                primaryButtons = !disableActions && [
                    acceptButton
                ];
            }
        }
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $8d7c140c81666045$export$6a458a35d6b615d0), {
            cancelButton: cancelButton,
            secondaryButtons: secondaryButtons,
            primaryButtons: primaryButtons
        });
    }, [
        disableActions,
        feedbackForm,
        onRetry,
        onCopy,
        onCancel,
        applications,
        formatMessage,
        agent,
        refineDropdownItems,
        isNewPaletteEnabled,
        forceFocusRing,
        onRefinementClick
    ]);
    const generatedContentPreview = /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp",
            hideHorizontalRule ? "_ca0qze3t" : !isNewPaletteEnabled && "_x3doia51 _n7zlia51"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
            space: "space.200",
            children: [
                !shouldHidePreviewContent && canShowVisualDiffPreview && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                    content: !hasValidDiffPreview && formatMessage((0, $63aac829604a098b$export$2e2bcd8739ae039).highlightDifferencesDisabledTooltip),
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $82gXq.default), {
                                isDisabled: !hasValidDiffPreview,
                                label: formatMessage((0, $63aac829604a098b$export$2e2bcd8739ae039).highlightDifferencesLabel),
                                id: "diff-preview-toggle",
                                testId: "diff-preview-toggle",
                                isChecked: isDiffPreviewVisible && hasValidDiffPreview,
                                onChange: handleToggleDiffPreviewVisibility
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                xcss: !hasValidDiffPreview && $6037e01702f2a193$var$hasDiffPreviewStyles.default,
                                as: "label",
                                htmlFor: "diff-preview-toggle",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    children: formatMessage((0, $63aac829604a098b$export$2e2bcd8739ae039).highlightDifferencesLabel)
                                })
                            })
                        ]
                    })
                }),
                shouldHidePreviewContent ? null : canShowVisualDiffPreview && isDiffPreviewVisible && hasValidDiffPreview ? diffPreview : /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        (0, $dh538.fg)('aifc_create_enabled') && "_ca0q12x7"
                    ]),
                    children: preview
                }),
                actionButtons
            ]
        })
    });
    const promptForm = isViewingLatestResponse && PromptEditor && /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp",
            "_1tke1x2r _vchhusvi _247hidpf _txhsidpf _zu32idpf _16d6idpf"
        ]),
        children: isViewingLatestResponse && /*#__PURE__*/ (0, $l998X.jsx)((0, $2NU90.PromptForm), {
            type: "interrogate",
            showButtons: isInputActive,
            autoFocus: true,
            placeholder: `${initialPlaceholder}${isNewPaletteEnabled ? '...' : ''}`,
            value: inputValue,
            adfValue: inputADFValue,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            onFormSubmit: onSubmit,
            onInputChange: onInputChange,
            onADFChange: onADFChange,
            onInputFocus: handleOnInputFocus,
            focusInputRef: focusInputRef,
            clearInputRef: clearInputRef,
            PromptEditor: PromptEditor,
            enableLinks: true,
            fireParentActionButton: firePrimaryApplication,
            focusParentActionButton: setForceFocusRing,
            showLogo: false,
            onInputBlur: onInterrogateBlur
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        /* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop */ className: (0, $gMc0m.default)([
            "_zulp1b66 _1e0c1txw _2lx21bp4 _4cvr1y6m",
            "preview-screen"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $40sdH.FloatingContainer), {
            disablePadding: true,
            "data-testid": "preview-screen" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            ,
            className: (0, $gMc0m.default)([
                "_1e0c1txw _2lx21bp4",
                `preview-screen ${(0, $kuYGt.AI_MODAL_SCREEN_CLASS)}`
            ]),
            rainbowBorder: false,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                    children: formatMessage((0, $63aac829604a098b$export$2e2bcd8739ae039).previewScreenLabel)
                }),
                !isNewPaletteEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $8PgnR.LatestPromptHeader), {
                    parentPresetPromptLabel: parentPresetPromptLabel,
                    childShortTitle: childShortTitle,
                    prompt: promptString,
                    promptADF: latestPrompt?.userADFInput,
                    presetTitle: presetTitleString,
                    agent: agent,
                    providerFactory: providerFactory,
                    schema: schema,
                    onEditPromptClick: onEditPromptClick,
                    showBack: showBack,
                    onBack: onBack,
                    onClose: onClose,
                    isClearTitle: isClearTitle
                }),
                generatedContentPreview,
                !isNewPaletteEnabled && promptForm,
                /*#__PURE__*/ (0, $l998X.jsx)((0, $jHWjW.Footer), {
                    brand: agent ? 'rovo' : 'atlassian-intelligence',
                    disclaimer: disclaimer,
                    showDisclaimer: true,
                    showBetaLozenge: showBetaLozenge,
                    showFeedback: isNewPaletteEnabled && canInlineStreamChanges,
                    feedbackForm: feedbackForm
                })
            ]
        })
    });
};
module.exports["PreviewScreen"] = $6037e01702f2a193$export$9f3706359963c421;

});

parcelRegister("2NU90", function(module, exports) {
/* PromptForm.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /** @jsxfrag */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $b4emg = parcelRequire("b4emg");

var $hbEec = parcelRequire("hbEec");


var $3Mg7y = parcelRequire("3Mg7y");


var $dh538 = parcelRequire("dh538");


var $imfiV = parcelRequire("imfiV");

/* AtlassianIntelligenceLogo.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $id7ja = parcelRequire("id7ja");

const $25e983087c409c2b$var$CustomGlyph = (props)=>// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M14.5 14.5L17.5 17.5",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M9.5 14.5L6.5 17.5",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M9.5 9.5L6.5 6.5",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M14.5 9.5L17.5 6.5",
                stroke: "currentColor",
                strokeWidth: "1.5",
                strokeLinecap: "square"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.0001 16V19",
                stroke: "currentColor",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M8.00012 12L5.00012 12",
                stroke: "currentColor",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M12.0001 8.00002L12.0001 4.99999",
                stroke: "currentColor",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M16.0002 12L19.0002 12",
                stroke: "currentColor",
                strokeWidth: "1.5"
            })
        ]
    });
const $25e983087c409c2b$export$b58d43d92d088553 = (props)=>// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $l998X.jsx)((0, $id7ja.default), {
        glyph: $25e983087c409c2b$var$CustomGlyph,
        primaryColor: "var(--ds-icon-brand, #1868DB)",
        ...props
    });



var $9q1Mo = parcelRequire("9q1Mo");


var $7PdHP = parcelRequire("7PdHP");

/* SubmitButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $1qfLF = parcelRequire("1qfLF");


var $4fdTR = parcelRequire("4fdTR");





var $3gadb = parcelRequire("3gadb");


var $510uT = parcelRequire("510uT");


var $cgtv4 = parcelRequire("cgtv4");

var $df1dec83f4c60008$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    submitLabel: {
        id: "fabric.editor.ai.screens.prompt.submitLabel",
        defaultMessage: "Submit"
    },
    submitTooltip: {
        id: "fabric.editor.ai.screens.prompt.submitTooltip",
        defaultMessage: "Send to AI"
    }
});


const $265d55187973d7e1$export$8b7b7cdfb85d78c5 = ({ disabled: disabled, tabIndex: tabIndex, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const icon = (0, $dh538.fg)('aifc_create_enabled') ? (0, (/*@__PURE__*/$parcel$interopDefault($4fdTR))) : (0, $510uT.default);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: formatMessage((0, $df1dec83f4c60008$export$2e2bcd8739ae039).submitTooltip),
        hideTooltipOnClick: true,
        position: "top",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
            label: formatMessage((0, $df1dec83f4c60008$export$2e2bcd8739ae039).submitLabel),
            onClick: onClick,
            testId: "submit-icon-button",
            isDisabled: disabled,
            icon: icon,
            appearance: "subtle",
            spacing: "compact",
            tabIndex: tabIndex
        })
    });
};





var $f5a9d679cc9fd470$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    logo: {
        id: "fabric.editor.ai.commandPalette.promptForm.logo",
        defaultMessage: "Atlassian Intelligence Logo"
    }
});


const $964c4428d6c8e6f2$var$commonTextStyles = null;
const $964c4428d6c8e6f2$var$formGapStyles = null; // Make form height equals the height of its parent to prevent the form from growing out of the parent
const $964c4428d6c8e6f2$var$formHeightStyles = null; // Prevent form inner from growing out of form
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $964c4428d6c8e6f2$var$formInnerHeightStyles = null; // input's line-height is 20px, logo/button's height is 24px, need to adjust the height
const $964c4428d6c8e6f2$var$nextToInputStyles = null;
const $964c4428d6c8e6f2$var$selfStartStyles = null;
const $964c4428d6c8e6f2$var$formContainerStyles = null;
const $964c4428d6c8e6f2$var$newPaletteStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $964c4428d6c8e6f2$var$formStyles = null;
const $964c4428d6c8e6f2$var$formPaddingTopStyles = null;
const $964c4428d6c8e6f2$var$formInnerStyles = null;
const $964c4428d6c8e6f2$var$formInnerPaddingTopStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $964c4428d6c8e6f2$var$buttonWrapperStyles = null;
const $964c4428d6c8e6f2$export$416523684d97c4ad = ({ type: type = 'user-input', onFormSubmit: onFormSubmit, value: value = '', showButtons: showButtons = true, tag: tag, autoFocus: autoFocus = true, onInputChange: onInputChange, onADFChange: onADFChange, onInputFocus: onInputFocus, onInputBlur: onInputBlur, placeholder: placeholder, focusInputRef: focusInputRef, clearInputRef: clearInputRef, showLogo: showLogo = true, onInputKeyDown: onInputKeyDown, adfValue: adfValue, enableLinks: enableLinks, PromptEditor: PromptEditor, showBack: showBack, onBack: onBack, onInputKeyUp: onInputKeyUp, fireParentActionButton: fireParentActionButton, focusParentActionButton: focusParentActionButton, refinementTagRef: refinementTagRef })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [setBreakpointElement, { breakpoint: breakpoint }] = (0, $imfiV.useElementBreakpoints)();
    const blurInputRef = (0, $42omo.useRef)(undefined);
    const [isComposing, setIsComposing] = (0, $42omo.useState)(false);
    const [isLozengeSelected, setIsLozengeSelected] = (0, $42omo.useState)(false);
    const lastAdfValue = (0, $42omo.useRef)((0, $b4emg.getEmptyADF)());
    const isPromptInputEmpty = Boolean((0, $hbEec.isEmpty)(lastAdfValue?.current) && adfValue && (0, $hbEec.isEmpty)(adfValue));
    const handleOnCompositionStart = (0, $42omo.useCallback)(()=>{
        setIsComposing(true);
    }, []);
    const handleOnCompositionEnd = (0, $42omo.useCallback)(()=>{
        setIsComposing(false);
    }, []);
    const handleKeyUp = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((event)=>{
        if (isPromptInputEmpty && focusParentActionButton) focusParentActionButton(true);
        onInputKeyUp && onInputKeyUp(event);
    }, [
        focusParentActionButton,
        onInputKeyUp,
        isPromptInputEmpty
    ]);
    const handleInputFocus = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        setIsLozengeSelected(false);
        if (onInputFocus) onInputFocus();
    }, [
        onInputFocus
    ]);
    const handleKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((event)=>{
        /**
     * If the key is printable or escape, we should remove the focus ring
     * that is applied to the parent insert or replace button
     */ if ((event.key.length === 1 || event.key === 'Escape') && focusParentActionButton) focusParentActionButton(false);
        if (event.key === 'Backspace' && onBack) {
            // This shortcuts the default functionality by placing focus on the refinement tag
            // instead of removing the tag
            if (!isLozengeSelected && isPromptInputEmpty && refinementTagRef?.current) {
                refinementTagRef.current.getElementsByTagName('button')[0].focus();
                setIsLozengeSelected(true);
                return;
            }
            event.stopPropagation();
            if (isPromptInputEmpty) onBack();
        }
        if (event.key === 'Enter' && [
            event.altKey,
            event.metaKey,
            event.ctrlKey
        ].every((isPressed)=>!isPressed)) {
            event.stopPropagation(); // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const target = event.target;
            if (isComposing) return;
             // If the prompt input is empty, we should fire the parent action button
            // on Enter, which will either be replace or insert
            if (isPromptInputEmpty && fireParentActionButton) {
                fireParentActionButton();
                return;
            } // Handles a case where the user presses enter if refinement tag's close button or the
            // cancel button is focused
            if ([
                'close-button-refinement-tag',
                'cancel-icon-button',
                'cancel-esc-button',
                'back-icon-button'
            ].includes(target.getAttribute('data-testid') ?? '')) return;
             // Handles every other case that is not a "shift + enter"
            if (!event.shiftKey) {
                event.preventDefault();
                onFormSubmit(value);
            }
        } /**
       * Return focus back to the input if the user is typing
       * and the refinement tag removing button is focused.
       * When editor_a11y_focus_trap_ai is on, we also exclude the Tab key
       * as that causes focus to be trapped in the refinement button.
       */ 
        if ((0, $dh538.fg)('editor_a11y_focus_trap_ai')) {
            if (![
                'Enter',
                'Backspace',
                'Tab'
            ].includes(event.key) && refinementTagRef?.current && refinementTagRef.current.contains(document.activeElement)) document.getElementById('ak-editor-textarea')?.focus();
        } else if (![
            'Enter',
            'Backspace'
        ].includes(event.key) && refinementTagRef?.current && refinementTagRef.current.contains(document.activeElement)) document.getElementById('ak-editor-textarea')?.focus();
    }, [
        focusParentActionButton,
        onBack,
        refinementTagRef,
        isLozengeSelected,
        isPromptInputEmpty,
        isComposing,
        fireParentActionButton,
        onFormSubmit,
        value
    ]);
    const onADFChange_ = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((input)=>{
        lastAdfValue.current = adfValue ?? (0, $b4emg.getEmptyADF)();
        if (onADFChange) onADFChange(input);
    }, [
        onADFChange,
        adfValue
    ]);
    const onInputChange_ = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((newValue)=>{
        if (onInputChange) onInputChange(newValue);
    }, [
        onInputChange
    ]);
    const handleSubmitClick = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback(()=>{
        onFormSubmit(value);
    }, [
        onFormSubmit,
        value
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)("div" // ED-19496: We avoid propagating enter keypresses
    , {
        // since products like Bitbucket might have parent forms
        // that listen for keydown events to trigger form submission
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        ref: setBreakpointElement,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _1bah1y6m _4cvr1y6m"
        ]),
        children: [
            showLogo && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_19pk1i6y _otyr1i6y _1e0c1txw _2lx2vrvc _2hwx1b66 _4cvr1h6o _1wpz1wug",
                    breakpoint <= (0, $imfiV.Breakpoint).Small && "_1wpzynz6"
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3Mg7y))), {
                    color: "var(--ds-icon, #292A2E)",
                    label: formatMessage((0, $f5a9d679cc9fd470$export$2e2bcd8739ae039).logo),
                    spacing: "spacious",
                    LEGACY_fallbackIcon: (0, $25e983087c409c2b$export$b58d43d92d088553),
                    LEGACY_size: "medium"
                })
            }),
            showBack && /*#__PURE__*/ (0, $l998X.jsx)((0, $9q1Mo.BackIconButton), {
                inPromptHeader: true,
                stopPropagation: true,
                onClick: onBack
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            , {
                className: (0, $gMc0m.default)([
                    "_rcujidpf _o81cidpf _1l6uidpf _149midpf _1vhmkb7n _tqf3kb7n _1rnvf1ug _if291txw _2b921bp4",
                    "_zulp1b66",
                    showLogo && "_ca0qv77o",
                    "_4t3i1osq",
                    type === 'interrogate' && (0, $dh538.fg)('aifc_create_enabled') && "_2rko12b0 _189ee4h9 _1h6d1l7x _1dqonqa1 _ca0qu2gc _u5f3utpp _n3tdu2gc _19bvutpp",
                    "ai-modal-prompt-form"
                ]),
                "data-testid": "ai-modal-prompt-form",
                children: [
                    tag,
                    /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        className: (0, $gMc0m.default)([
                            "_11c82smr _1nmz1hna",
                            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw",
                            !!tag && "_ca0q1b66",
                            "_1tkeidpf"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $7PdHP.PromptEditorWrapper), {
                                PromptEditor: PromptEditor,
                                type: type,
                                focusInputRef: focusInputRef,
                                blurInputRef: blurInputRef,
                                clearInputRef: clearInputRef,
                                autoFocus: autoFocus,
                                defaultValue: adfValue,
                                onInputChange: onInputChange_,
                                onADFChange: onADFChange_,
                                placeholder: placeholder,
                                onFocus: handleInputFocus,
                                onBlur: onInputBlur,
                                onKeyDown: onInputKeyDown,
                                onCompositionStart: handleOnCompositionStart,
                                onCompositionEnd: handleOnCompositionEnd,
                                enableLinks: enableLinks
                            }),
                            showButtons && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                className: (0, $gMc0m.default)([
                                    "_1aaxusic _1e0c1txw _18u01b66"
                                ]),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $265d55187973d7e1$export$8b7b7cdfb85d78c5), {
                                    disabled: !value,
                                    onClick: handleSubmitClick
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
module.exports["PromptForm"] = $964c4428d6c8e6f2$export$416523684d97c4ad;

});

parcelRegister("7PdHP", function(module, exports) {
/* PromptEditorWrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dQl1W = parcelRequire("dQl1W");

const $2676c5921c742a31$var$promptEditorWrapperStylesUnbounded = null;
const $2676c5921c742a31$var$promptEditorWrapperStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $2676c5921c742a31$var$promptEditorWrapperOverflowStyles = null; // The types PromptEditorType should mirror what is in the editor-ai-injected-editors package
const $2676c5921c742a31$export$b0a649d08575ac09 = ({ type: type, PromptEditor: PromptEditor, defaultValue: defaultValue, autoFocus: autoFocus, focusInputRef: focusInputRef, blurInputRef: blurInputRef, clearInputRef: clearInputRef, placeholder: placeholder, enableLinks: enableLinks, onInputChange: onInputChange, onADFChange: onADFChange, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, submit: submit })=>{
    const setFocusHandlers = (0, $42omo.useCallback)((blur, focus)=>{
        if (blurInputRef) blurInputRef.current = blur;
        if (focusInputRef) focusInputRef.current = focus;
    }, [
        blurInputRef,
        focusInputRef
    ]);
    const setClearHandler = (0, $42omo.useCallback)((clear)=>{
        if (clearInputRef) clearInputRef.current = clear;
    }, [
        clearInputRef
    ]); // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const componentId = (0, $42omo.useMemo)(()=>`${placeholder}-${(0, $dQl1W.v4)()}`, [
        placeholder
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": "ai-experience-prompt-input",
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c11p5 _kqswh2mm",
            "_1hxngktf _hmumidpf _12k3idpf _q5yz1wug _dcw6idpf _2ih3idpf",
            "_w79o1m6u _1hxn1tcg"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)(PromptEditor, {
            type: type,
            autoFocus: autoFocus,
            defaultValue: defaultValue,
            placeholder: placeholder,
            onInputChange: onInputChange,
            onADFChange: onADFChange,
            setFocusHandlers: setFocusHandlers,
            setClearHandler: setClearHandler,
            enableLinks: enableLinks,
            submit: submit
        }, componentId)
    });
};
module.exports["PromptEditorWrapper"] = $2676c5921c742a31$export$b0a649d08575ac09;

});

parcelRegister("510uT", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $b08c7be14e35e8a5$var$Enter = ()=>/*#__PURE__*/ (0, $l998X.jsx)("svg", {
        width: "14",
        height: "12",
        viewBox: "0 0 14 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
            d: "M4.63477 11.2256C5.12012 11.2256 5.44141 10.8906 5.44141 10.4326C5.44141 10.1729 5.33203 9.98828 5.18164 9.83789L4.18359 8.86719L3.41113 8.24512L4.61426 8.2998H10.9102C12.4688 8.2998 13.1387 7.62988 13.1387 6.07129V2.89258C13.1387 1.33398 12.4688 0.657227 10.9102 0.657227H8.06641C7.58105 0.657227 7.21875 1.0332 7.21875 1.49121C7.21875 1.95605 7.58105 2.33203 8.06641 2.33203H10.835C11.3135 2.33203 11.5049 2.5166 11.5049 3.00195V5.96191C11.5049 6.44043 11.3135 6.63184 10.835 6.63184H4.61426L3.41113 6.68652L4.18359 6.06445L5.18164 5.10059C5.33203 4.94336 5.44141 4.76562 5.44141 4.50586C5.44141 4.04785 5.12012 3.70605 4.63477 3.70605C4.42285 3.70605 4.19727 3.80176 4.0332 3.96582L1.10742 6.85059C0.950195 7.00781 0.861328 7.24023 0.861328 7.46582C0.861328 7.69141 0.950195 7.93066 1.10742 8.08105L4.0332 10.9658C4.19727 11.1367 4.42285 11.2256 4.63477 11.2256Z",
            fill: "currentColor"
        })
    });
var $b08c7be14e35e8a5$export$2e2bcd8739ae039 = $b08c7be14e35e8a5$var$Enter;
module.exports["default"] = $b08c7be14e35e8a5$export$2e2bcd8739ae039;

});

parcelRegister("87Gms", function(module, exports) {
/* ToolbarNestedDropdownMenu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $52EPl = parcelRequire("52EPl");


var $gdv5Z = parcelRequire("gdv5Z");


var $2GVu1 = parcelRequire("2GVu1");

const $a02d656535d0452b$var$styles = {
    scrollContainer: "_c71lnklw _18m91wug"
};
const $a02d656535d0452b$export$21541b912954ea8c = ({ elemBefore: elemBefore, text: text, elemAfter: elemAfter, children: children, isDisabled: isDisabled, testId: testId, dropdownTestId: dropdownTestId, enableMaxHeight: enableMaxHeight = false, onClick: onClick, shouldFitContainer: shouldFitContainer = false })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
        shouldFitContainer: shouldFitContainer,
        placement: "right-start",
        testId: dropdownTestId,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2GVu1.ToolbarDropdownItem), {
                elemBefore: elemBefore,
                elemAfter: elemAfter,
                isSelected: triggerProps.isSelected,
                onClick: (e)=>{
                    onClick && onClick(e);
                    triggerProps.onClick && triggerProps.onClick(e);
                },
                testId: testId,
                triggerRef: triggerProps.triggerRef,
                hasNestedDropdownMenu: true,
                isDisabled: isDisabled,
                children: text
            }),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1bHXt.cx)(enableMaxHeight && $a02d656535d0452b$var$styles.scrollContainer),
            children: children
        })
    });
};
module.exports["ToolbarNestedDropdownMenu"] = $a02d656535d0452b$export$21541b912954ea8c;

});

parcelRegister("dMzWS", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $9fbdeaf1889c5c72$export$2b86bedf890eab8() {
    const [element, setElement] = (0, $42omo.useState)(null);
    const [width, setWidth] = (0, $42omo.useState)(0);
    const [height, setHeight] = (0, $42omo.useState)(0);
    (0, $42omo.useEffect)(()=>{
        if (!element) return;
        // Do no use here ResizeObserverEntry.contentRect as it is only a content size (without padding and border)
        // and we need the size of the whole element.
        const updateSize = ()=>{
            const { width: width, height: height } = element.getBoundingClientRect();
            setWidth(width);
            setHeight(height);
        };
        const resizeObserver = new ResizeObserver(updateSize);
        resizeObserver.observe(element);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        element
    ]);
    return (0, $42omo.useMemo)(()=>[
            setElement,
            {
                width: width,
                height: height
            }
        ], [
        width,
        height
    ]);
}
module.exports["useElementSize"] = $9fbdeaf1889c5c72$export$2b86bedf890eab8;

});

parcelRegister("9q1Mo", function(module, exports) {
/* BackIconButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $laHi9 = parcelRequire("laHi9");


var $1s5hv = parcelRequire("1s5hv");


var $aYaJs = parcelRequire("aYaJs");

const $b8ba0bd35619d8be$var$inPromptHeaderStyles = {
    default: "_1e0c116y _2hwx1b66"
};
const $b8ba0bd35619d8be$var$toolTipProps = {
    position: 'top'
};
const $b8ba0bd35619d8be$export$dcf44e0bed76850 = ({ inPromptHeader: inPromptHeader, isDisabled: isDisabled = false, stopPropagation: stopPropagation, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const onClickIconButton = (0, $42omo.useCallback)((event)=>{
        if (stopPropagation) event.stopPropagation();
        onClick?.();
    }, [
        stopPropagation,
        onClick
    ]);
    const btn = /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        isDisabled: isDisabled,
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($laHi9))), {
                label: iconProps.label,
                testId: iconProps.testId,
                size: "small"
            }),
        label: formatMessage((0, $aYaJs.default).backLabel),
        spacing: "compact",
        isTooltipDisabled: isDisabled,
        onClick: onClickIconButton,
        testId: "back-icon-button",
        tooltip: $b8ba0bd35619d8be$var$toolTipProps
    });
    if (inPromptHeader) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        xcss: $b8ba0bd35619d8be$var$inPromptHeaderStyles.default,
        children: btn
    });
    return btn;
};
module.exports["BackIconButton"] = $b8ba0bd35619d8be$export$dcf44e0bed76850;

});

parcelRegister("aYaJs", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf82cabcf0fa8110$export$2e2bcd8739ae039);

var $cgtv4 = parcelRequire("cgtv4");

var $cf82cabcf0fa8110$export$2e2bcd8739ae039 = (0, $cgtv4.defineMessages)({
    backLabel: {
        id: "fabric.editor.ai.components.backIconButton.backLabel",
        defaultMessage: "Back"
    }
});

});


$parcel$global.rlb("8zMTq")
//# sourceMappingURL=FullPageEditorComponent.6afd5d62.js.map
